import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import _each from "lodash/each";
import _groupBy from "lodash/groupBy";
import { gsap, Cubic } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import SideNavi from "~/js/home/side-navi";
import Anchorlink from "~/js/common/anchorlink";
import Modal from "~/js/common/modal";
import LazyImage from "~/js/common/lazy-image";
import Carousel from "~/js/common/carousel";
import Tooltip from "~/js/common/tooltip";
import ImportantModal from "~/js/common/important-modal";
import common from "~/js/common/common";
export default class Catalog {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      } else if (mutation.type === "catalogClick") {
        this.updateCatalog(state.catalog.catalogIndex);
      } else if (mutation.type === "closeModal") {
        this.clearModal();
      }
    });
    // ware, glasses, ...
    this.CATALOG_MODE_WARE = "ware";
    this.CATALOG_MODE_GLASSES = "glasses";
    this.catalogMode = this.CATALOG_MODE_WARE;
    this.MODAL_NAME = "modal-catalog";
    this.DEFAULT_LAYOUT = "type-4-2";
    this.MONTHS = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
    this.header = new Header();
    this.footer = new Footer();
    this.catalogEl = document.querySelector(".js-catalogmain");
    this.catalogWrapEl = document.querySelector(".js-catalog-wrap");
    Common.setupScrollY();
    //// to server ====
    this.fetch();
    //// to Local =====
    /*this.json = [
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JC101",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC101_15.jpg?v=1686311661",
        defaultImage: 4,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: [] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: [] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: [] },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#212121",
            colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC101_15.jpg?v=1686311661", "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725"]
          }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc101",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JJ103",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_51_a.jpg?v=1686103726",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 51,
            colorName: "LIGHT YELLOW",
            colorCode: "#E8E1C2",
            colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_51_a.jpg?v=1686103726", "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00824F",
            colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_63_a.jpg?v=1686103366", "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725"]
          },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_68_a.jpg?v=1686103725"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj103",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JJ103",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_63_a.jpg?v=1686103366",
        defaultImage: 2,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_51_a.jpg?v=1686103726"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_63_a.jpg?v=1686103366"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_68_a.jpg?v=1686103725"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj103",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JJ103",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_68_a.jpg?v=1686103725",
        defaultImage: 3,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_51_a.jpg?v=1686103726"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_63_a.jpg?v=1686103366"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_68_a.jpg?v=1686103725"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj103",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JJ103",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725",
        defaultImage: 4,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_51_a.jpg?v=1686103726"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_63_a.jpg?v=1686103366"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_68_a.jpg?v=1686103725"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ103_15_a.jpg?v=1686103725"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj103",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JK102",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_51_a.jpg?v=1686104463",
        defaultImage: 1,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_51_a.jpg?v=1686104463"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_63_a.jpg?v=1686104463"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_68_a.jpg?v=1686104464"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_15_a.jpg?v=1686104412"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk102",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JK102",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_63_a.jpg?v=1686104463",
        defaultImage: 2,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_51_a.jpg?v=1686104463"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_63_a.jpg?v=1686104463"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_68_a.jpg?v=1686104464"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_15_a.jpg?v=1686104412"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk102",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JK102",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_68_a.jpg?v=1686104464",
        defaultImage: 3,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_51_a.jpg?v=1686104463"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_63_a.jpg?v=1686104463"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_68_a.jpg?v=1686104464"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_15_a.jpg?v=1686104412"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk102",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JK102",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_15_a.jpg?v=1686104412",
        defaultImage: 4,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_51_a.jpg?v=1686104463"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_63_a.jpg?v=1686104463"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_68_a.jpg?v=1686104464"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK102_15_a.jpg?v=1686104412"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk102",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JF104",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_51_a.jpg?v=1686104412",
        defaultImage: 1,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_51_a.jpg?v=1686104412"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_63_a.jpg?v=1686104412"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_68_a.jpg?v=1686104412"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_15_a.jpg?v=1686104412"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf104",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JF104",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_63_a.jpg?v=1686104412",
        defaultImage: 2,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_51_a.jpg?v=1686104412"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_63_a.jpg?v=1686104412"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_68_a.jpg?v=1686104412"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_15_a.jpg?v=1686104412"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf104",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JF104",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_68_a.jpg?v=1686104412",
        defaultImage: 3,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_51_a.jpg?v=1686104412"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_63_a.jpg?v=1686104412"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_68_a.jpg?v=1686104412"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_15_a.jpg?v=1686104412"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf104",
        layout: ""
      },
      {
        category: "JULY",
        name: "MC JULY",
        productNumber: "HP33JF104",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_15_a.jpg?v=1686104412",
        defaultImage: 4,
        colors: [
          { colorNumber: 51, colorName: "LIGHT YELLOW", colorCode: "#E8E1C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_51_a.jpg?v=1686104412"] },
          { colorNumber: 63, colorName: "EMERALD GREEN", colorCode: "#00824F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_63_a.jpg?v=1686104412"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#2D2F23", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_68_a.jpg?v=1686104412"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#212121", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF104_15_a.jpg?v=1686104412"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf104",
        layout: ""
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JA350",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_62.jpg?v=1686311661",
        defaultImage: 1,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_62.jpg?v=1686311661"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_24.jpg?v=1686311662"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_12.jpg?v=1686311661"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja350",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JA350",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_24.jpg?v=1686311662",
        defaultImage: 2,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_62.jpg?v=1686311661"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_24.jpg?v=1686311662"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_12.jpg?v=1686311661"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja350",
        layout: ""
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JA350",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_12.jpg?v=1686311661",
        defaultImage: 3,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_62.jpg?v=1686311661"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_24.jpg?v=1686311662"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA350_12.jpg?v=1686311661"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja350",
        layout: ""
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JK351",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK351_62.jpg?v=1686706402",
        defaultImage: 1,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK351_62.jpg?v=1686706402"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: [] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK351_12.jpg?v=1686706402"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk351",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JK351",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK351_12.jpg?v=1686706402",
        defaultImage: 3,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK351_62.jpg?v=1686706402"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: [] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK351_12.jpg?v=1686706402"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk351",
        layout: ""
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JF352",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_62.jpg?v=1686705067",
        defaultImage: 1,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_62.jpg?v=1686705067"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_24.jpg?v=1686705067"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_12.jpg?v=1686705068"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf352",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JF352",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_24.jpg?v=1686705067",
        defaultImage: 2,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_62.jpg?v=1686705067"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_24.jpg?v=1686705067"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_12.jpg?v=1686705068"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf352",
        layout: ""
      },
      {
        category: "JULY",
        name: "TRIANGULAR GRID",
        productNumber: "HP33JF352",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_12.jpg?v=1686705068",
        defaultImage: 3,
        colors: [
          { colorNumber: 62, colorName: "GREEN", colorCode: "#10373E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_62.jpg?v=1686705067"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#AD060D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_24.jpg?v=1686705067"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#3D4547", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF352_12.jpg?v=1686705068"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf352",
        layout: ""
      },
      {
        category: "JULY",
        name: "FRAMEWORK",
        productNumber: "HP33JL375",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL375_11.jpg?v=1686314890",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#ADB2B6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL375_11.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC3B0F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL375_33.jpg?v=1686314890"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#1F3741", colorImages: [] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl375",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "FRAMEWORK",
        productNumber: "HP33JL375",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL375_33.jpg?v=1686314890",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#ADB2B6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL375_11.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC3B0F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL375_33.jpg?v=1686314890"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#1F3741", colorImages: [] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl375",
        layout: ""
      },
      {
        category: "JULY",
        name: "FRAMEWORK",
        productNumber: "HP33JF377",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF377_11.jpg?v=1686706309",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#ADB2B6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF377_11.jpg?v=1686706309"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC3B0F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF377_33.jpg?v=1686706308"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#1F3741", colorImages: [] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf377",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "FRAMEWORK",
        productNumber: "HP33JF377",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF377_33.jpg?v=1686706308",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#ADB2B6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF377_11.jpg?v=1686706309"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC3B0F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF377_33.jpg?v=1686706308"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#1F3741", colorImages: [] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf377",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JF135",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_61_a.jpg?v=1686118954",
        defaultImage: 1,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_15_a.jpg?v=1686118955"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf135",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JF135",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_67_a.jpg?v=1686118954",
        defaultImage: 2,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_15_a.jpg?v=1686118955"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf135",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JF135",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_15_a.jpg?v=1686118955",
        defaultImage: 3,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF135_15_a.jpg?v=1686118955"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf135",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JF136",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_61_a.jpg?v=1686118954",
        defaultImage: 1,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_15_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf136",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JF136",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_67_a.jpg?v=1686118954",
        defaultImage: 2,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_15_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf136",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JF136",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_15_a.jpg?v=1686118954",
        defaultImage: 3,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF136_15_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf136",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JI137",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_61_a.jpg?v=1686118954",
        defaultImage: 1,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_15_a.jpg?v=1686118954"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ji137",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JI137",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_67_a.jpg?v=1686118954",
        defaultImage: 2,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_15_a.jpg?v=1686118954"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ji137",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BOTTOMS 1",
        productNumber: "HP33JI137",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_15_a.jpg?v=1686118954",
        defaultImage: 3,
        colors: [
          { colorNumber: 61, colorName: "LIGHT GREEN", colorCode: "#AFD94E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_61_a.jpg?v=1686118954"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#142823", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_67_a.jpg?v=1686118954"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL137_15_a.jpg?v=1686118954"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ji137",
        layout: ""
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KC210",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_70.jpg?v=1686314890",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_70.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_33.jpg?v=1686314891"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_15.jpg?v=1686314890"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kc210",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KC210",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_33.jpg?v=1686314891",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_70.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_33.jpg?v=1686314891"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_15.jpg?v=1686314890"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kc210",
        layout: ""
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KC210",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_15.jpg?v=1686314890",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_70.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_33.jpg?v=1686314891"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KC210_15.jpg?v=1686314890"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kc210",
        layout: ""
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KN211",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_70.jpg?v=1686314890",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_70.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_33.jpg?v=1686314890"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_15.jpg?v=1686314890"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn211",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KN211",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_33.jpg?v=1686314890",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_70.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_33.jpg?v=1686314890"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_15.jpg?v=1686314890"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn211",
        layout: ""
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KN211",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_15.jpg?v=1686314890",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_70.jpg?v=1686314890"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_33.jpg?v=1686314890"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN211_15.jpg?v=1686314890"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn211",
        layout: ""
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KF212",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_70.jpg?v=1686878482",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_70.jpg?v=1686878482"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_33.jpg?v=1686878481"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_15.jpg?v=1686878481"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kf212",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KF212",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_33.jpg?v=1686878481",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_70.jpg?v=1686878482"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_33.jpg?v=1686878481"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_15.jpg?v=1686878481"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kf212",
        layout: ""
      },
      {
        category: "JULY",
        name: "RUSTIC KNIT",
        productNumber: "HP33KF212",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_15.jpg?v=1686878481",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#9CAEBE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_70.jpg?v=1686878482"] },
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#F4702F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_33.jpg?v=1686878481"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF212_15.jpg?v=1686878481"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kf212",
        layout: ""
      },
      {
        category: "JULY",
        name: "EDGE COAT",
        productNumber: "HP33FA315",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_11.jpg?v=1687159864",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CFCFCF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_11.jpg?v=1687159864"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#7B8899", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_72.jpg?v=1687160434"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#5A271D", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_15.jpg?v=1687159876"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa315",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "EDGE COAT",
        productNumber: "HP33FA315",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_72.jpg?v=1687160434",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CFCFCF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_11.jpg?v=1687159864"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#7B8899", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_72.jpg?v=1687160434"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#5A271D", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_15.jpg?v=1687159876"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa315",
        layout: ""
      },
      {
        category: "JULY",
        name: "EDGE COAT",
        productNumber: "HP33FA315",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_15.jpg?v=1687159876",
        defaultImage: 4,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CFCFCF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_11.jpg?v=1687159864"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#7B8899", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_72.jpg?v=1687160434"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#5A271D", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA315_15.jpg?v=1687159876"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa315",
        layout: ""
      },
      {
        category: "JULY",
        name: "EDGE COAT",
        productNumber: "HP33FC316",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_11.jpg?v=1687163421",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CFCFCF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_11.jpg?v=1687163421"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#7B8899", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_72.jpg?v=1687163421"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#5A271D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_44.jpg?v=1687163421"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_15.jpg?v=1687163421"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fc316",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "EDGE COAT",
        productNumber: "HP33FC316",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_72.jpg?v=1687163421",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CFCFCF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_11.jpg?v=1687163421"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#7B8899", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_72.jpg?v=1687163421"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#5A271D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_44.jpg?v=1687163421"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_15.jpg?v=1687163421"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fc316",
        layout: ""
      },
      {
        category: "JULY",
        name: "EDGE COAT",
        productNumber: "HP33FC316",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_44.jpg?v=1687163421",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CFCFCF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_11.jpg?v=1687163421"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#7B8899", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_72.jpg?v=1687163421"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#5A271D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_44.jpg?v=1687163421"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_15.jpg?v=1687163421"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fc316",
        layout: ""
      },
      {
        category: "JULY",
        name: "EDGE COAT",
        productNumber: "HP33FC316",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_15.jpg?v=1687163421",
        defaultImage: 4,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CFCFCF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_11.jpg?v=1687163421"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#7B8899", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_72.jpg?v=1687163421"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#5A271D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_44.jpg?v=1687163421"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC316_15.jpg?v=1687163421"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fc316",
        layout: ""
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ335",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_19_a.jpg?v=1686118954",
        defaultImage: 1,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj335",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ335",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_71_a.jpg?v=1686118954",
        defaultImage: 2,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj335",
        layout: ""
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ335",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_65_a.jpg?v=1686118954",
        defaultImage: 3,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj335",
        layout: ""
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ335",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_14_a.jpg?v=1686118954",
        defaultImage: 4,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ335_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj335",
        layout: ""
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ336",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_19_a.jpg?v=1686118954",
        defaultImage: 1,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj336",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ336",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_71_a.jpg?v=1686118954",
        defaultImage: 2,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj336",
        layout: ""
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ336",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_65_a.jpg?v=1686118954",
        defaultImage: 3,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj336",
        layout: ""
      },
      {
        category: "JULY",
        name: "SL SHIRT",
        productNumber: "HP33FJ336",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_14_a.jpg?v=1686118954",
        defaultImage: 4,
        colors: [
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#BBB4D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_19_a.jpg?v=1686118954"] },
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#7FB5D6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_71_a.jpg?v=1686118954"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#604B30", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_65_a.jpg?v=1686118954"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#333333", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ336_14_a.jpg?v=1686118954"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj336",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BELT",
        productNumber: "HP33AH404",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_60.jpg?v=1686118954",
        defaultImage: 1,
        colors: [
          { colorNumber: 60, colorName: "LIGHT GREEN×GRAY", colorCode: "#A8C661", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_60.jpg?v=1686118954"] },
          { colorNumber: 88, colorName: "PURPLE×BROWN", colorCode: "#AB92BC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_88.jpg?v=1686118954"] },
          { colorNumber: 78, colorName: "BLUE×BLACK", colorCode: "#384668", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_78.jpg?v=1686118954"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ah404",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JULY",
        name: "PLEATS BELT",
        productNumber: "HP33AH404",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_88.jpg?v=1686118954",
        defaultImage: 2,
        colors: [
          { colorNumber: 60, colorName: "LIGHT GREEN×GRAY", colorCode: "#A8C661", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_60.jpg?v=1686118954"] },
          { colorNumber: 88, colorName: "PURPLE×BROWN", colorCode: "#AB92BC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_88.jpg?v=1686118954"] },
          { colorNumber: 78, colorName: "BLUE×BLACK", colorCode: "#384668", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_78.jpg?v=1686118954"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ah404",
        layout: ""
      },
      {
        category: "JULY",
        name: "PLEATS BELT",
        productNumber: "HP33AH404",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_78.jpg?v=1686118954",
        defaultImage: 3,
        colors: [
          { colorNumber: 60, colorName: "LIGHT GREEN×GRAY", colorCode: "#A8C661", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_60.jpg?v=1686118954"] },
          { colorNumber: 88, colorName: "PURPLE×BROWN", colorCode: "#AB92BC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_88.jpg?v=1686118954"] },
          { colorNumber: 78, colorName: "BLUE×BLACK", colorCode: "#384668", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AH404_78.jpg?v=1686118954"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ah404",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JL106",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_33_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_16_a.jpg?v=1686119489"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl106",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JL106",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_16_a.jpg?v=1686119489",
        defaultImage: 2,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_16_a.jpg?v=1686119489"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl106",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JL106",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_67_a.jpg?v=1686119488",
        defaultImage: 3,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_16_a.jpg?v=1686119489"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl106",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JL106",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_15_a.jpg?v=1686119489",
        defaultImage: 4,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_16_a.jpg?v=1686119489"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL106_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl106",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JM107",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_33_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_16_a.jpg?v=1686812221"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm107",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JM107",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_16_a.jpg?v=1686812221",
        defaultImage: 2,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_16_a.jpg?v=1686812221"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm107",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JM107",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_67_a.jpg?v=1686119488",
        defaultImage: 3,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_16_a.jpg?v=1686812221"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm107",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JM107",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_15_a.jpg?v=1686119489",
        defaultImage: 4,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_16_a.jpg?v=1686812221"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM107_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm107",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JE108",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_33_a.jpg?v=1686119488",
        defaultImage: 1,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_33_a.jpg?v=1686119488"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je108",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JE108",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_16_a.jpg?v=1686119488",
        defaultImage: 2,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_33_a.jpg?v=1686119488"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je108",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JE108",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_67_a.jpg?v=1686119488",
        defaultImage: 3,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_33_a.jpg?v=1686119488"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je108",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JE108",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_15_a.jpg?v=1686119489",
        defaultImage: 4,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_33_a.jpg?v=1686119488"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_67_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE108_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je108",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JF109",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_33_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_67.jpg?v=1686812221"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_15_a.jpg?v=1686119489"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf109",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JF109",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_16_a.jpg?v=1686119488",
        defaultImage: 2,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_67.jpg?v=1686812221"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_15_a.jpg?v=1686119489"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf109",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JF109",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_67.jpg?v=1686812221",
        defaultImage: 3,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_67.jpg?v=1686812221"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_15_a.jpg?v=1686119489"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf109",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "MC AUGUST",
        productNumber: "HP33JF109",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_15_a.jpg?v=1686119489",
        defaultImage: 4,
        colors: [
          { colorNumber: 33, colorName: "POWERFUL ORANGE", colorCode: "#EC4C20", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_33_a.jpg?v=1686119489"] },
          { colorNumber: 16, colorName: "MINT GRAY", colorCode: "#616E6B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_16_a.jpg?v=1686119488"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#202821", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_67.jpg?v=1686812221"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#171717", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF109_15_a.jpg?v=1686119489"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf109",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD150",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_70_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_68_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd150",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD150",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_65_a.jpg?v=1686119489",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_68_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd150",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD150",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_68_a.jpg?v=1686119489",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_68_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd150",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD150",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_15_a.jpg?v=1686119488",
        defaultImage: 4,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_68_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD150_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd150",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD154",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_70_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd154",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD154",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_65_a.jpg?v=1686119489",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd154",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD154",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_68_a.jpg?v=1686119488",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd154",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JD154",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_15_a.jpg?v=1686119488",
        defaultImage: 4,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD154_15_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd154",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JE151",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_70_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_65_a.jpg?v=1686119488"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_68_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je151",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JE151",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_65_a.jpg?v=1686119488",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_65_a.jpg?v=1686119488"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_68_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je151",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JE151",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_68_a.jpg?v=1686119489",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_65_a.jpg?v=1686119488"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE151_68_a.jpg?v=1686119489"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je151",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JF152",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_70_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_68_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf152",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JF152",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_65_a.jpg?v=1686119489",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_68_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf152",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JF152",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_68_a.jpg?v=1686119488",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF152_68_a.jpg?v=1686119488"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf152",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JF153",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_70_a.jpg?v=1686119489",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf153",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JF153",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_65_a.jpg?v=1686119489",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf153",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JF153",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_68_a.jpg?v=1686119488",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf153",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "TAILORED PLEATS 1",
        productNumber: "HP33JF153",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_15_a.jpg?v=1686119488",
        defaultImage: 4,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C1DC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_70_a.jpg?v=1686119489"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#9E8E6C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_65_a.jpg?v=1686119489"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#5F5B48", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_68_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF153_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf153",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "THREE BY SIX",
        productNumber: "HP33JA381",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_11.jpg?v=1686707775",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D1D1D1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_11.jpg?v=1686707775"] },
          { colorNumber: 27, colorName: "CRIMSON RED", colorCode: "#BB2E34", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1118", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_15.jpg?v=1686707775"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja381",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "THREE BY SIX",
        productNumber: "HP33JA381",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_15.jpg?v=1686707775",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D1D1D1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_11.jpg?v=1686707775"] },
          { colorNumber: 27, colorName: "CRIMSON RED", colorCode: "#BB2E34", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1118", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_15.jpg?v=1686707775"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja381",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "THREE BY SIX",
        productNumber: "HP33JL380",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL380_11.jpg?v=1686314890",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D1D1D1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL380_11.jpg?v=1686314890"] },
          { colorNumber: 27, colorName: "CRIMSON RED", colorCode: "#BB2E34", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1118", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_15.jpg?v=1686707775"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl380",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "THREE BY SIX",
        productNumber: "HP33JL380",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL380_15.jpg?v=1686314890",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D1D1D1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL380_11.jpg?v=1686314890"] },
          { colorNumber: 27, colorName: "CRIMSON RED", colorCode: "#BB2E34", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1118", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA381_15.jpg?v=1686707775"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl380",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "THREE BY SIX",
        productNumber: "HP33JF382",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_11.jpg?v=1687228036",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D1D1D1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_11.jpg?v=1687228036"] },
          { colorNumber: 27, colorName: "CRIMSON RED", colorCode: "#BB2E34", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_27.jpg?v=1686313684"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1118", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_15.jpg?v=1686313684"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf382",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "AUGUST",
        name: "THREE BY SIX",
        productNumber: "HP33JF382",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_27.jpg?v=1686313684",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D1D1D1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_11.jpg?v=1687228036"] },
          { colorNumber: 27, colorName: "CRIMSON RED", colorCode: "#BB2E34", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_27.jpg?v=1686313684"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1118", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_15.jpg?v=1686313684"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf382",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "THREE BY SIX",
        productNumber: "HP33JF382",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_15.jpg?v=1686313684",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D1D1D1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_11.jpg?v=1687228036"] },
          { colorNumber: 27, colorName: "CRIMSON RED", colorCode: "#BB2E34", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_27.jpg?v=1686313684"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1118", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF382_15.jpg?v=1686313684"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf382",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK201",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_41_a.jpg?v=1686119488",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_72_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk201",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK201",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_52_a.jpg?v=1686119489",
        defaultImage: 2,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_72_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk201",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK201",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_72_a.jpg?v=1686119489",
        defaultImage: 3,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_72_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk201",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK201",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_15_a.jpg?v=1686119488",
        defaultImage: 4,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_72_a.jpg?v=1686119489"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK201_15_a.jpg?v=1686119488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk201",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK202",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_41_a.jpg?v=1686119488",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_72_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk202",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK202",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_52_a.jpg?v=1686119489",
        defaultImage: 2,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_72_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk202",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK202",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_72_a.jpg?v=1686119488",
        defaultImage: 3,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_72_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk202",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "RELEASE-T 1",
        productNumber: "HP33JK202",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_15_a.jpg?v=1686119489",
        defaultImage: 4,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#EDE2CC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_41_a.jpg?v=1686119488"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#D9C25E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_52_a.jpg?v=1686119489"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6B809C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_72_a.jpg?v=1686119488"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK202_15_a.jpg?v=1686119489"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk202",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "EDGE SHIRT",
        productNumber: "HP33FJ340",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_11.jpg?v=1686311661",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#A7AEB8", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_11.jpg?v=1686311661"] },
          { colorNumber: 42, colorName: "GREIGE", colorCode: "#D2BEA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_42.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1215", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_15.jpg?v=1686311661"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj340",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "AUGUST",
        name: "EDGE SHIRT",
        productNumber: "HP33FJ340",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_42.jpg?v=1686311661",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#A7AEB8", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_11.jpg?v=1686311661"] },
          { colorNumber: 42, colorName: "GREIGE", colorCode: "#D2BEA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_42.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1215", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_15.jpg?v=1686311661"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj340",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "EDGE SHIRT",
        productNumber: "HP33FJ340",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_15.jpg?v=1686311661",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#A7AEB8", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_11.jpg?v=1686311661"] },
          { colorNumber: 42, colorName: "GREIGE", colorCode: "#D2BEA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_42.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1215", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ340_15.jpg?v=1686311661"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj340",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "EDGE SHIRT",
        productNumber: "HP33FJ341",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_11.jpg?v=1686311661",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#A7AEB8", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_11.jpg?v=1686311661"] },
          { colorNumber: 42, colorName: "GREIGE", colorCode: "#D2BEA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_42.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1215", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_15.jpg?v=1686311662"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj341",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "AUGUST",
        name: "EDGE SHIRT",
        productNumber: "HP33FJ341",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_42.jpg?v=1686311661",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#A7AEB8", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_11.jpg?v=1686311661"] },
          { colorNumber: 42, colorName: "GREIGE", colorCode: "#D2BEA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_42.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1215", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_15.jpg?v=1686311662"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj341",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "EDGE SHIRT",
        productNumber: "HP33FJ341",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_15.jpg?v=1686311662",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#A7AEB8", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_11.jpg?v=1686311661"] },
          { colorNumber: 42, colorName: "GREIGE", colorCode: "#D2BEA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_42.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E1215", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ341_15.jpg?v=1686311662"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj341",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "PLEATS CAP",
        productNumber: "HP33AA403",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_71.jpg?v=1686878998",
        defaultImage: 1,
        colors: [
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#9DB5D7", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_71.jpg?v=1686878998"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#49556E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_72.jpg?v=1686879234"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#96523F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_44.jpg?v=1686879234"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#050505", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_15.jpg?v=1686879234"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33aa403",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "AUGUST",
        name: "PLEATS CAP",
        productNumber: "HP33AA403",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_72.jpg?v=1686879234",
        defaultImage: 2,
        colors: [
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#9DB5D7", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_71.jpg?v=1686878998"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#49556E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_72.jpg?v=1686879234"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#96523F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_44.jpg?v=1686879234"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#050505", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_15.jpg?v=1686879234"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33aa403",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "PLEATS CAP",
        productNumber: "HP33AA403",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_44.jpg?v=1686879234",
        defaultImage: 3,
        colors: [
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#9DB5D7", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_71.jpg?v=1686878998"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#49556E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_72.jpg?v=1686879234"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#96523F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_44.jpg?v=1686879234"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#050505", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_15.jpg?v=1686879234"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33aa403",
        layout: ""
      },
      {
        category: "AUGUST",
        name: "PLEATS CAP",
        productNumber: "HP33AA403",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_15.jpg?v=1686879234",
        defaultImage: 4,
        colors: [
          { colorNumber: 71, colorName: "LIGHT BLUE", colorCode: "#9DB5D7", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_71.jpg?v=1686878998"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#49556E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_72.jpg?v=1686879234"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#96523F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_44.jpg?v=1686879234"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#050505", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AA403_15.jpg?v=1686879234"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-07-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33aa403",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JA114",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_70_a.jpg?v=1686120463",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_15_a.jpg?v=1686120463"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja114",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JA114",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_84_a.jpg?v=1686120463",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_15_a.jpg?v=1686120463"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja114",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JA114",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_48_a.jpg?v=1686120463",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_15_a.jpg?v=1686120463"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja114",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JA114",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_15_a.jpg?v=1686120463",
        defaultImage: 4,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA114_15_a.jpg?v=1686120463"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja114",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JL111",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_70_a.jpg?v=1686120463",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_15_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl111",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JL111",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_84_a.jpg?v=1686120463",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_15_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl111",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JL111",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_48_a.jpg?v=1686120463",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_15_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl111",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JL111",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_15_a.jpg?v=1686120463",
        defaultImage: 4,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL111_15_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl111",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JK112",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_70_a.jpg?v=1686120463",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_48_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk112",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JK112",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_84_a.jpg?v=1686120463",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_48_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk112",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JK112",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_48_a.jpg?v=1686120463",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK112_48_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk112",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JF113",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_70_a.jpg?v=1686120463",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_15_a.jpg?v=1686120463"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf113",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JF113",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_84_a.jpg?v=1686120463",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_15_a.jpg?v=1686120463"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf113",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JF113",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_48_a.jpg?v=1686120463",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_15_a.jpg?v=1686120463"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf113",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "MC SEPTEMBER",
        productNumber: "HP33JF113",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_15_a.jpg?v=1686120463",
        defaultImage: 4,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#C9D1DF", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_70_a.jpg?v=1686120463"] },
          { colorNumber: 84, colorName: "VIOLA VIOLET", colorCode: "#3D33A2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_84_a.jpg?v=1686120463"] },
          { colorNumber: 48, colorName: "COCOA BROWN", colorCode: "#634331", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_48_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#000000", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF113_15_a.jpg?v=1686120463"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf113",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "EMBROIDERY PLEATS",
        productNumber: "HP33JC355",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC355_15.jpg?v=1686311662",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#CFE4E6", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#05040A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC355_15.jpg?v=1686311662"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc355",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "SEPTE MBER",
        name: "EMBROIDERY PLEATS",
        productNumber: "HP33JK356",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK356_70.jpg?v=1686706496",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#CFE4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK356_70.jpg?v=1686706496"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#05040A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK356_15.jpg?v=1686706496"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk356",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "EMBROIDERY PLEATS",
        productNumber: "HP33JK356",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK356_15.jpg?v=1686706496",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#CFE4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK356_70.jpg?v=1686314890"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#05040A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK356_15.jpg?v=1686706496"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk356",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "EMBROIDERY PLEATS",
        productNumber: "HP33JF357",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF357_70.jpg?v=1686708031",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#CFE4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF357_70.jpg?v=1686708031"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#05040A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF357_15.jpg?v=1686708032"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf357",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "EMBROIDERY PLEATS",
        productNumber: "HP33JF357",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF357_15.jpg?v=1686708032",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#CFE4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF357_70.jpg?v=1686708031"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#05040A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF357_15.jpg?v=1686708032"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf357",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "EMBROIDERY PLEATS",
        productNumber: "HP33JF358",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF358_70.jpg?v=1686705875",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#CFE4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF358_70.jpg?v=1686705875"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#05040A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF358_15.jpg?v=1686705875"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf358",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "EMBROIDERY PLEATS",
        productNumber: "HP33JF358",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF358_15.jpg?v=1686705875",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#CFE4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF358_70.jpg?v=1686705875"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#05040A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF358_15.jpg?v=1686705875"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf358",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "UNFOLD",
        productNumber: "HP33JC367",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC367_70.jpg?v=1686311661",
        defaultImage: 1,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C0CD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC367_70.jpg?v=1686311661"] },
          { colorNumber: 45, colorName: "SOIL BROWN", colorCode: "#7D6A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC367_45.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#111320", colorImages: [] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc367",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "UNFOLD",
        productNumber: "HP33JC367",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC367_45.jpg?v=1686311661",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C0CD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC367_70.jpg?v=1686311661"] },
          { colorNumber: 45, colorName: "SOIL BROWN", colorCode: "#7D6A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC367_45.jpg?v=1686311661"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#111320", colorImages: [] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc367",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "UNFOLD",
        productNumber: "HP33JE365",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE365_45.jpg?v=1687323795",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C0CD", colorImages: [] },
          { colorNumber: 45, colorName: "SOIL BROWN", colorCode: "#7D6A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE365_45.jpg?v=1687323795"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#111320", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE365_15.jpg?v=1687323775"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je365",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "UNFOLD",
        productNumber: "HP33JE365",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE365_15.jpg?v=1687323775",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C0CD", colorImages: [] },
          { colorNumber: 45, colorName: "SOIL BROWN", colorCode: "#7D6A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE365_45.jpg?v=1687323795"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#111320", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE365_15.jpg?v=1687323775"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je365",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "UNFOLD",
        productNumber: "HP33JF366",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF366_45.jpg?v=1687327637",
        defaultImage: 2,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C0CD", colorImages: [] },
          { colorNumber: 45, colorName: "SOIL BROWN", colorCode: "#7D6A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF366_45.jpg?v=1687327637"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#111320", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF366_15.jpg?v=1687327623"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf366",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "UNFOLD",
        productNumber: "HP33JF366",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF366_15.jpg?v=1687327623",
        defaultImage: 3,
        colors: [
          { colorNumber: 70, colorName: "AQUA BLUE", colorCode: "#B8C0CD", colorImages: [] },
          { colorNumber: 45, colorName: "SOIL BROWN", colorCode: "#7D6A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF366_45.jpg?v=1687327637"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#111320", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF366_15.jpg?v=1687327623"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf366",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "INLAID KNIT",
        productNumber: "HP33KF216",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_41.jpg?v=1687327601",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7C9A7", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_41.jpg?v=1687327601"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#37432B", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#533322", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_44.jpg?v=1687327576"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#090909", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_15.jpg?v=1687327589"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kf216",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "SEPTE MBER",
        name: "INLAID KNIT",
        productNumber: "HP33KF216",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_44.jpg?v=1687327576",
        defaultImage: 3,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7C9A7", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_41.jpg?v=1687327601"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#37432B", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#533322", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_44.jpg?v=1687327576"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#090909", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_15.jpg?v=1687327589"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kf216",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "INLAID KNIT",
        productNumber: "HP33KF216",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_15.jpg?v=1687327589",
        defaultImage: 4,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7C9A7", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_41.jpg?v=1687327601"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#37432B", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#533322", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_44.jpg?v=1687327576"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#090909", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KF216_15.jpg?v=1687327589"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kf216",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "Black Turtleneck Top",
        productNumber: "HP33JK100",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_01_a.jpg?v=1686120463",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#DBDBDB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_01_a.jpg?v=1686120463"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#523834", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_44_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_15_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk100",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "SEPTE MBER",
        name: "Black Turtleneck Top",
        productNumber: "HP33JK100",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_44_a.jpg?v=1686120463",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#DBDBDB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_01_a.jpg?v=1686120463"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#523834", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_44_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_15_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk100",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "Black Turtleneck Top",
        productNumber: "HP33JK100",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_15_a.jpg?v=1686120463",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#DBDBDB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_01_a.jpg?v=1686120463"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#523834", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_44_a.jpg?v=1686120463"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK100_15_a.jpg?v=1686120463"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk100",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "TRUSS",
        productNumber: "HP33FA330",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_32.jpg?v=1686309628",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#B2B2B2", colorImages: [] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#9E3E1B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_32.jpg?v=1686309628"] },
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#473A7F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_81.jpg?v=1686309628"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#131512", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_15.jpg?v=1686309628"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa330",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "SEPTE MBER",
        name: "TRUSS",
        productNumber: "HP33FA330",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_81.jpg?v=1686309628",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#B2B2B2", colorImages: [] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#9E3E1B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_32.jpg?v=1686309628"] },
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#473A7F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_81.jpg?v=1686309628"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#131512", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_15.jpg?v=1686309628"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa330",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "TRUSS",
        productNumber: "HP33FA330",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_15.jpg?v=1686309628",
        defaultImage: 4,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#B2B2B2", colorImages: [] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#9E3E1B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_32.jpg?v=1686309628"] },
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#473A7F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_81.jpg?v=1686309628"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#131512", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA330_15.jpg?v=1686309628"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa330",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FC308",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC308_24.jpg?v=1686309628",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: [] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: [] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC308_24.jpg?v=1686309628"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: [] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fc308",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FD305",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_01_a.jpg?v=1687226334",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_01_a.jpg?v=1687226334"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_72_a.jpg?v=1687226642"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_24_a.jpg?v=1687226654"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_44_a.jpg?v=1687226350"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fd305",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FD305",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_72_a.jpg?v=1687226642",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_01_a.jpg?v=1687226334"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_72_a.jpg?v=1687226642"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_24_a.jpg?v=1687226654"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_44_a.jpg?v=1687226350"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fd305",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FD305",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_24_a.jpg?v=1687226654",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_01_a.jpg?v=1687226334"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_72_a.jpg?v=1687226642"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_24_a.jpg?v=1687226654"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_44_a.jpg?v=1687226350"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fd305",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FD305",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_44_a.jpg?v=1687226350",
        defaultImage: 4,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_01_a.jpg?v=1687226334"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_72_a.jpg?v=1687226642"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_24_a.jpg?v=1687226654"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FD305_44_a.jpg?v=1687226350"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fd305",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF306",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_01_a.jpg?v=1687226961",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_01_a.jpg?v=1687226961"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_72_a.jpg?v=1687226996"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_24_a.jpg?v=1687226974"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_44_a.jpg?v=1687226985"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff306",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF306",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_72_a.jpg?v=1687226996",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_01_a.jpg?v=1687226961"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_72_a.jpg?v=1687226996"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_24_a.jpg?v=1687226974"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_44_a.jpg?v=1687226985"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff306",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF306",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_24_a.jpg?v=1687226974",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_01_a.jpg?v=1687226961"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_72_a.jpg?v=1687226996"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_24_a.jpg?v=1687226974"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_44_a.jpg?v=1687226985"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff306",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF306",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_44_a.jpg?v=1687226985",
        defaultImage: 4,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_01_a.jpg?v=1687226961"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_72_a.jpg?v=1687226996"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_24_a.jpg?v=1687226974"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF306_44_a.jpg?v=1687226985"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff306",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF307",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_01_a.jpg?v=1687227182",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_01_a.jpg?v=1687227182"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_72_a.jpg?v=1687227205"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_24_a.jpg?v=1687227194"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_44_a.jpg?v=1687227159"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff307",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF307",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_72_a.jpg?v=1687227205",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_01_a.jpg?v=1687227182"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_72_a.jpg?v=1687227205"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_24_a.jpg?v=1687227194"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_44_a.jpg?v=1687227159"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff307",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF307",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_24_a.jpg?v=1687227194",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_01_a.jpg?v=1687227182"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_72_a.jpg?v=1687227205"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_24_a.jpg?v=1687227194"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_44_a.jpg?v=1687227159"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff307",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "KERSEY PLEATS",
        productNumber: "HP33FF307",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_44_a.jpg?v=1687227159",
        defaultImage: 4,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E8E2D2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_01_a.jpg?v=1687227182"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#8DA4AC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_72_a.jpg?v=1687227205"] },
          { colorNumber: 24, colorName: "RED", colorCode: "#8E232A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_24_a.jpg?v=1687227194"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#4B3736", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF307_44_a.jpg?v=1687227159"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff307",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG407",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_52.jpg?v=1687225568",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_52.jpg?v=1687225568"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_41.jpg?v=1687225597"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_62.jpg?v=1687225610"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_15.jpg?v=1687225626"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag407",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG407",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_41.jpg?v=1687225597",
        defaultImage: 2,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_52.jpg?v=1687225568"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_41.jpg?v=1687225597"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_62.jpg?v=1687225610"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_15.jpg?v=1687225626"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag407",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG407",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_62.jpg?v=1687225610",
        defaultImage: 3,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_52.jpg?v=1687225568"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_41.jpg?v=1687225597"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_62.jpg?v=1687225610"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_15.jpg?v=1687225626"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag407",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG407",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_15.jpg?v=1687225626",
        defaultImage: 4,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_52.jpg?v=1687225568"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_41.jpg?v=1687225597"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_62.jpg?v=1687225610"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG407_15.jpg?v=1687225626"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag407",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG408",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_52.jpg?v=1687225781",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_52.jpg?v=1687225781"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_41.jpg?v=1687225836"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_62.jpg?v=1687225813"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_15.jpg?v=1687225796"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag408",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG408",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_41.jpg?v=1687225836",
        defaultImage: 2,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_52.jpg?v=1687225781"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_41.jpg?v=1687225836"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_62.jpg?v=1687225813"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_15.jpg?v=1687225796"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag408",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG408",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_62.jpg?v=1687225813",
        defaultImage: 3,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_52.jpg?v=1687225781"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_41.jpg?v=1687225836"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_62.jpg?v=1687225813"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_15.jpg?v=1687225796"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag408",
        layout: ""
      },
      {
        category: "SEPTE MBER",
        name: "POCKET",
        productNumber: "HP33AG408",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_15.jpg?v=1687225796",
        defaultImage: 4,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#D7D3CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_52.jpg?v=1687225781"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#BCA32E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_41.jpg?v=1687225836"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#255120", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_62.jpg?v=1687225813"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#030303", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG408_15.jpg?v=1687225796"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-08-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag408",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JC116",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_54_a.jpg?v=1686207832",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_46_a.jpg?v=1686207833"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc116",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JC116",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_46_a.jpg?v=1686207833",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_46_a.jpg?v=1686207833"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc116",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JC116",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_18_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_46_a.jpg?v=1686207833"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc116",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JC116",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_46_a.jpg?v=1686207833"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC116_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc116",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JF119",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_54_a.jpg?v=1686207833",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf119",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JF119",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_46_a.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf119",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JF119",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_18_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf119",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JF119",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF119_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf119",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JJ117",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_54_a.jpg?v=1686207832",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj117",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JJ117",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_46_a.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj117",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JJ117",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_18_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj117",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JJ117",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_54_a.jpg?v=1686207832"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JJ117_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jj117",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JK118",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_54_a.jpg?v=1686207833",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk118",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JK118",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_46_a.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk118",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JK118",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_18_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk118",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "MC OCTOBER",
        productNumber: "HP33JK118",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#CEC445", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_54_a.jpg?v=1686207833"] },
          { colorNumber: 46, colorName: "GINGER BROWN", colorCode: "#9E5841", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_46_a.jpg?v=1686207832"] },
          { colorNumber: 18, colorName: "SLATE GRAY", colorCode: "#575757", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_18_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0B0B0B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK118_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk118",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD155",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_54_a.jpg?v=1686207832",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd155",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD155",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_74_a.jpg?v=1686207833",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd155",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD155",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_47_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd155",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD155",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_47_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD155_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd155",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD156",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_54_a.jpg?v=1686207833",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_54_a.jpg?v=1686207833"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd156",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD156",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_74_a.jpg?v=1686207833",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_54_a.jpg?v=1686207833"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd156",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD156",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_47_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_54_a.jpg?v=1686207833"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd156",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JD156",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_54_a.jpg?v=1686207833"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_74_a.jpg?v=1686207833"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD156_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd156",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JE157",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_54_a.jpg?v=1686207832",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je157",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JE157",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_74_a.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je157",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JE157",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_47_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je157",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JE157",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE157_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je157",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JF158",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_54_a.jpg?v=1686207832",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_47_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf158",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JF158",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_74_a.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_47_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf158",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JF158",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_47_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF158_47_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf158",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JF159",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_54_a.jpg?v=1686207832",
        defaultImage: 1,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf159",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JF159",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_74_a.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf159",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JF159",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_47_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf159",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "TAILORED PLEATS 2",
        productNumber: "HP33JF159",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 54, colorName: "CITRON YELLOW", colorCode: "#D2C847", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_54_a.jpg?v=1686207832"] },
          { colorNumber: 74, colorName: "DEEP MARINE BLUE", colorCode: "#00646F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_74_a.jpg?v=1686207832"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#423135", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_47_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#151515", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF159_15_a.jpg?v=1686207832"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf159",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "COMPLEAT TROUSERS",
        productNumber: "HP33JF145",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_17_a.jpg?v=1686207832",
        defaultImage: 1,
        colors: [
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#818573", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_17_a.jpg?v=1686207832"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#282721", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_68_a.jpg?v=1686207832"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#29343B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_67_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#101010", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf145",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "COMPLEAT TROUSERS",
        productNumber: "HP33JF145",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_68_a.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#818573", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_17_a.jpg?v=1686207832"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#282721", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_68_a.jpg?v=1686207832"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#29343B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_67_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#101010", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf145",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "COMPLEAT TROUSERS",
        productNumber: "HP33JF145",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_67_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#818573", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_17_a.jpg?v=1686207832"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#282721", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_68_a.jpg?v=1686207832"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#29343B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_67_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#101010", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf145",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "COMPLEAT TROUSERS",
        productNumber: "HP33JF145",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_15_a.jpg?v=1686207832",
        defaultImage: 4,
        colors: [
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#818573", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_17_a.jpg?v=1686207832"] },
          { colorNumber: 68, colorName: "EBONY KHAKI", colorCode: "#282721", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_68_a.jpg?v=1686207832"] },
          { colorNumber: 67, colorName: "DARK GREEN", colorCode: "#29343B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_67_a.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#101010", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF145_15_a.jpg?v=1686207832"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf145",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "FRAMEWORK KNIT",
        productNumber: "HP33KN220",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_81_a.jpg?v=1686207833",
        defaultImage: 1,
        colors: [
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#857AAB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_81_a.jpg?v=1686207833"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5B5148", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_65_a.jpg?v=1686207833"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_15_a.jpg?v=1686207832"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn220",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "OCTOBER",
        name: "FRAMEWORK KNIT",
        productNumber: "HP33KN220",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_65_a.jpg?v=1686207833",
        defaultImage: 2,
        colors: [
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#857AAB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_81_a.jpg?v=1686207833"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5B5148", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_65_a.jpg?v=1686207833"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_15_a.jpg?v=1686207832"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn220",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "FRAMEWORK KNIT",
        productNumber: "HP33KN220",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_15_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#857AAB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_81_a.jpg?v=1686207833"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5B5148", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_65_a.jpg?v=1686207833"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN220_15_a.jpg?v=1686207832"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn220",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "FRAMEWORK KNIT",
        productNumber: "HP33KN221",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_81_a.jpg?v=1686207833",
        defaultImage: 1,
        colors: [
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#857AAB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_81_a.jpg?v=1686207833"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5B5148", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_65_a.jpg?v=1686207833"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_15_a.jpg?v=1686207832"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn221",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "OCTOBER",
        name: "FRAMEWORK KNIT",
        productNumber: "HP33KN221",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_65_a.jpg?v=1686207833",
        defaultImage: 2,
        colors: [
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#857AAB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_81_a.jpg?v=1686207833"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5B5148", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_65_a.jpg?v=1686207833"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_15_a.jpg?v=1686207832"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn221",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "FRAMEWORK KNIT",
        productNumber: "HP33KN221",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_15_a.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 81, colorName: "PURPLE", colorCode: "#857AAB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_81_a.jpg?v=1686207833"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5B5148", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_65_a.jpg?v=1686207833"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#292929", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33KN221_15_a.jpg?v=1686207832"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33kn221",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "WOOL LIKE LIGHT",
        productNumber: "HP33FA300",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_12.jpg?v=1686302179",
        defaultImage: 1,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#837A71", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_12.jpg?v=1686302179"] },
          { colorNumber: 23, colorName: "DARK PINK", colorCode: "#725857", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_23.jpg?v=1686302179"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#11100C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_15.jpg?v=1686302179"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa300",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "OCTOBER",
        name: "WOOL LIKE LIGHT",
        productNumber: "HP33FA300",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_23.jpg?v=1686302179",
        defaultImage: 2,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#837A71", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_12.jpg?v=1686302179"] },
          { colorNumber: 23, colorName: "DARK PINK", colorCode: "#725857", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_23.jpg?v=1686302179"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#11100C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_15.jpg?v=1686302179"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa300",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "WOOL LIKE LIGHT",
        productNumber: "HP33FA300",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_15.jpg?v=1686302179",
        defaultImage: 3,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#837A71", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_12.jpg?v=1686302179"] },
          { colorNumber: 23, colorName: "DARK PINK", colorCode: "#725857", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_23.jpg?v=1686302179"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#11100C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA300_15.jpg?v=1686302179"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa300",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "CASCADE",
        productNumber: "HP33FC310",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC310_44.jpg?v=1686310488",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CCCCCC", colorImages: [] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#92C250", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#56483D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC310_44.jpg?v=1686310488"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fc310",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "OCTOBER",
        name: "CASCADE",
        productNumber: "HP33FF311",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF311_11.jpg?v=1686634660",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#CCCCCC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF311_11.jpg?v=1686634660"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#92C250", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#56483D", colorImages: [] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff311",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "OCTOBER",
        name: "PANEL COAT",
        productNumber: "HP33FA332",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA332_11.jpg?v=1686309628",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E0D9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA332_11.jpg?v=1686309628"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#E2604A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA332_32.jpg?v=1686309628"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#222C2B", colorImages: [] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa332",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "PANEL COAT",
        productNumber: "HP33FA332",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA332_32.jpg?v=1686309628",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E0D9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA332_11.jpg?v=1686309628"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#E2604A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FA332_32.jpg?v=1686309628"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#222C2B", colorImages: [] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fa332",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ345",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_01_a.jpg?v=1687227333",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_01_a.jpg?v=1687227333"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_32_a.jpg?v=1687227384"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_19_a.jpg?v=1687227495"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_14_a.jpg?v=1687227507"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj345",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ345",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_32_a.jpg?v=1687227384",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_01_a.jpg?v=1687227333"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_32_a.jpg?v=1687227384"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_19_a.jpg?v=1687227495"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_14_a.jpg?v=1687227507"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj345",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ345",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_19_a.jpg?v=1687227495",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_01_a.jpg?v=1687227333"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_32_a.jpg?v=1687227384"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_19_a.jpg?v=1687227495"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_14_a.jpg?v=1687227507"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj345",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ345",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_14_a.jpg?v=1687227507",
        defaultImage: 4,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_01_a.jpg?v=1687227333"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_32_a.jpg?v=1687227384"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_19_a.jpg?v=1687227495"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ345_14_a.jpg?v=1687227507"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj345",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ346",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_01_a.jpg?v=1687227735",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_01_a.jpg?v=1687227735"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_32_a.jpg?v=1687227758"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_19_a.jpg?v=1687227745"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_14_a.jpg?v=1687227720"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj346",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ346",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_32_a.jpg?v=1687227758",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_01_a.jpg?v=1687227735"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_32_a.jpg?v=1687227758"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_19_a.jpg?v=1687227745"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_14_a.jpg?v=1687227720"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj346",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ346",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_19_a.jpg?v=1687227745",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_01_a.jpg?v=1687227735"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_32_a.jpg?v=1687227758"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_19_a.jpg?v=1687227745"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_14_a.jpg?v=1687227720"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj346",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "STREAMLINE SHIRT",
        productNumber: "HP33FJ346",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_14_a.jpg?v=1687227720",
        defaultImage: 4,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#E9EAE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_01_a.jpg?v=1687227735"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#82370C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_32_a.jpg?v=1687227758"] },
          { colorNumber: 19, colorName: "BLUE GRAY", colorCode: "#928F98", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_19_a.jpg?v=1687227745"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5C5A5B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ346_14_a.jpg?v=1687227720"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj346",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "SEED STITCH SOCKS",
        productNumber: "HP33AI405",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_11.jpg?v=1686308504",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D3CCC6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_11.jpg?v=1686308504"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#F57130", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_32.jpg?v=1686308504"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93A595", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_62.jpg?v=1686308504"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6077C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_72.jpg?v=1686308504"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5A5859", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_14.jpg?v=1686308505"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ai405",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "OCTOBER",
        name: "SEED STITCH SOCKS",
        productNumber: "HP33AI405",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_32.jpg?v=1686308504",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D3CCC6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_11.jpg?v=1686308504"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#F57130", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_32.jpg?v=1686308504"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93A595", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_62.jpg?v=1686308504"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6077C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_72.jpg?v=1686308504"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5A5859", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_14.jpg?v=1686308505"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ai405",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "SEED STITCH SOCKS",
        productNumber: "HP33AI405",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_62.jpg?v=1686308504",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D3CCC6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_11.jpg?v=1686308504"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#F57130", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_32.jpg?v=1686308504"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93A595", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_62.jpg?v=1686308504"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6077C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_72.jpg?v=1686308504"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5A5859", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_14.jpg?v=1686308505"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ai405",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "SEED STITCH SOCKS",
        productNumber: "HP33AI405",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_72.jpg?v=1686308504",
        defaultImage: 4,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D3CCC6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_11.jpg?v=1686308504"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#F57130", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_32.jpg?v=1686308504"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93A595", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_62.jpg?v=1686308504"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6077C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_72.jpg?v=1686308504"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5A5859", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_14.jpg?v=1686308505"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ai405",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "OCTOBER",
        name: "SEED STITCH SOCKS",
        productNumber: "HP33AI405",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_14.jpg?v=1686308505",
        defaultImage: 5,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D3CCC6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_11.jpg?v=1686308504"] },
          { colorNumber: 32, colorName: "ORANGE", colorCode: "#F57130", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_32.jpg?v=1686308504"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93A595", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_62.jpg?v=1686308504"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#6077C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_72.jpg?v=1686308504"] },
          { colorNumber: 14, colorName: "CHARCOAL", colorCode: "#5A5859", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AI405_14.jpg?v=1686308505"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ai405",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "PLEATS DAYPACK",
        productNumber: "HP33AG401",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_11.jpg?v=1686207833",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D6D2CB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_11.jpg?v=1686207833"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#304C45", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_62.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2B2B2B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_15.jpg?v=1686207832"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag401",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "OCTOBER",
        name: "PLEATS DAYPACK",
        productNumber: "HP33AG401",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_62.jpg?v=1686207832",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D6D2CB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_11.jpg?v=1686207833"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#304C45", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_62.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2B2B2B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_15.jpg?v=1686207832"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag401",
        layout: ""
      },
      {
        category: "OCTOBER",
        name: "PLEATS DAYPACK",
        productNumber: "HP33AG401",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_15.jpg?v=1686207832",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#D6D2CB", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_11.jpg?v=1686207833"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#304C45", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_62.jpg?v=1686207832"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2B2B2B", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AG401_15.jpg?v=1686207832"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-09-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ag401",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JA121",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_25_a.jpg?v=1686207855",
        defaultImage: 1,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_25_a.jpg?v=1686207855"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_15_a.jpg?v=1686207854"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja121",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JA121",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_17_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_25_a.jpg?v=1686207855"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_15_a.jpg?v=1686207854"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja121",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JA121",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_73_a.jpg?v=1686207853",
        defaultImage: 3,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_25_a.jpg?v=1686207855"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_15_a.jpg?v=1686207854"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja121",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JA121",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_15_a.jpg?v=1686207854",
        defaultImage: 4,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_25_a.jpg?v=1686207855"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA121_15_a.jpg?v=1686207854"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja121",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JK123",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_25_a.jpg?v=1686207854",
        defaultImage: 1,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_15_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk123",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JK123",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_17_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_15_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk123",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JK123",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_73_a.jpg?v=1686207853",
        defaultImage: 3,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_15_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk123",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JK123",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_15_a.jpg?v=1686207853",
        defaultImage: 4,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF123_15_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk123",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JF124",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_25_a.jpg?v=1686207854",
        defaultImage: 1,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_15_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf124",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JF124",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_17_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_15_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf124",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JF124",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_73_a.jpg?v=1686207853",
        defaultImage: 3,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_15_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf124",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "MC NOVEMBER",
        productNumber: "HP33JF124",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_15_a.jpg?v=1686207853",
        defaultImage: 4,
        colors: [
          { colorNumber: 25, colorName: "MAGENTA", colorCode: "#D72083", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_25_a.jpg?v=1686207854"] },
          { colorNumber: 17, colorName: "BRONZE GRAY", colorCode: "#5F5F54", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_17_a.jpg?v=1686207854"] },
          { colorNumber: 73, colorName: "INK BLUE", colorCode: "#2A2E39", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_73_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#282828", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF124_15_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf124",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL180",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_77_a.jpg?v=1686207854",
        defaultImage: 1,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl180",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL180",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_82_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl180",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL180",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_26_a.jpg?v=1686207854",
        defaultImage: 3,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl180",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL180",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_69_a.jpg?v=1686207854",
        defaultImage: 4,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL180_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl180",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL181",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_77_a.jpg?v=1686207854",
        defaultImage: 1,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_69_a.jpg?v=1686207852"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl181",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL181",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_82_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_69_a.jpg?v=1686207852"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl181",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL181",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_26_a.jpg?v=1686207854",
        defaultImage: 3,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_69_a.jpg?v=1686207852"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl181",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JL181",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_69_a.jpg?v=1686207852",
        defaultImage: 4,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL181_69_a.jpg?v=1686207852"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl181",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK182",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_77_a.jpg?v=1686207853",
        defaultImage: 1,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_69_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk182",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK182",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_82_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_69_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk182",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK182",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_26_a.jpg?v=1686207854",
        defaultImage: 3,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_69_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk182",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK182",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_69_a.jpg?v=1686207853",
        defaultImage: 4,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK182_69_a.jpg?v=1686207853"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk182",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK183",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_77_a.jpg?v=1686207853",
        defaultImage: 1,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk183",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK183",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_82_a.jpg?v=1686207853",
        defaultImage: 2,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk183",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK183",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_26_a.jpg?v=1686207854",
        defaultImage: 3,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk183",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JK183",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_69_a.jpg?v=1686207854",
        defaultImage: 4,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF183_69_a.jpg?v=1686207854"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk183",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF184",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_77_a.jpg?v=1686207853",
        defaultImage: 1,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf184",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF184",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_82_a.jpg?v=1686207853",
        defaultImage: 2,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf184",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF184",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_26_a.jpg?v=1686207854",
        defaultImage: 3,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf184",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF184",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_69_a.jpg?v=1686207853",
        defaultImage: 4,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_77_a.jpg?v=1686207853"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_82_a.jpg?v=1686207853"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF184_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf184",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF185",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_77_a.jpg?v=1686207854",
        defaultImage: 1,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf185",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF185",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_82_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf185",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF185",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_26_a.jpg?v=1686207854",
        defaultImage: 3,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf185",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "COLOR PLEATS",
        productNumber: "HP33JF185",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_69_a.jpg?v=1686207853",
        defaultImage: 4,
        colors: [
          { colorNumber: 77, colorName: "LIGHT INDIGO", colorCode: "#D6E4E6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_77_a.jpg?v=1686207854"] },
          { colorNumber: 82, colorName: "LILAC PURPLE", colorCode: "#BDA9D3", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_82_a.jpg?v=1686207854"] },
          { colorNumber: 26, colorName: "TEA RED", colorCode: "#7C293F", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_26_a.jpg?v=1686207854"] },
          { colorNumber: 69, colorName: "DEEP GREEN", colorCode: "#404D49", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF185_69_a.jpg?v=1686207853"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf185",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "SKEW GRID",
        productNumber: "HP33JE371",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_49.jpg?v=1686311661",
        defaultImage: 1,
        colors: [
          { colorNumber: 49, colorName: "BROWN×SHELL PINK", colorCode: "#EEB7C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_49.jpg?v=1686311661"] },
          { colorNumber: 79, colorName: "GREEN×ICE GREEN", colorCode: "#C4E1C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_79.jpg?v=1686311661"] },
          { colorNumber: 8, colorName: "BLACK×LIGHT GRAY", colorCode: "#CEC9BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_08.jpg?v=1686311662"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je371",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "NOVEMBER",
        name: "SKEW GRID",
        productNumber: "HP33JE371",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_79.jpg?v=1686311661",
        defaultImage: 2,
        colors: [
          { colorNumber: 49, colorName: "BROWN×SHELL PINK", colorCode: "#EEB7C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_49.jpg?v=1686311661"] },
          { colorNumber: 79, colorName: "GREEN×ICE GREEN", colorCode: "#C4E1C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_79.jpg?v=1686311661"] },
          { colorNumber: 8, colorName: "BLACK×LIGHT GRAY", colorCode: "#CEC9BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_08.jpg?v=1686311662"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je371",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "SKEW GRID",
        productNumber: "HP33JE371",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_08.jpg?v=1686311662",
        defaultImage: 3,
        colors: [
          { colorNumber: 49, colorName: "BROWN×SHELL PINK", colorCode: "#EEB7C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_49.jpg?v=1686311661"] },
          { colorNumber: 79, colorName: "GREEN×ICE GREEN", colorCode: "#C4E1C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_79.jpg?v=1686311661"] },
          { colorNumber: 8, colorName: "BLACK×LIGHT GRAY", colorCode: "#CEC9BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE371_08.jpg?v=1686311662"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je371",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "SKEW GRID",
        productNumber: "HP33JF372",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_49.jpg?v=1686706115",
        defaultImage: 1,
        colors: [
          { colorNumber: 49, colorName: "BROWN×SHELL PINK", colorCode: "#EEB7C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_49.jpg?v=1686706115"] },
          { colorNumber: 79, colorName: "GREEN×ICE GREEN", colorCode: "#C4E1C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_79.jpg?v=1686706115"] },
          { colorNumber: 8, colorName: "BLACK×LIGHT GRAY", colorCode: "#CEC9BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_08.jpg?v=1686706115"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf372",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "NOVEMBER",
        name: "SKEW GRID",
        productNumber: "HP33JF372",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_79.jpg?v=1686706115",
        defaultImage: 2,
        colors: [
          { colorNumber: 49, colorName: "BROWN×SHELL PINK", colorCode: "#EEB7C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_49.jpg?v=1686706115"] },
          { colorNumber: 79, colorName: "GREEN×ICE GREEN", colorCode: "#C4E1C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_79.jpg?v=1686706115"] },
          { colorNumber: 8, colorName: "BLACK×LIGHT GRAY", colorCode: "#CEC9BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_08.jpg?v=1686706115"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf372",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "SKEW GRID",
        productNumber: "HP33JF372",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_08.jpg?v=1686706115",
        defaultImage: 3,
        colors: [
          { colorNumber: 49, colorName: "BROWN×SHELL PINK", colorCode: "#EEB7C2", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_49.jpg?v=1686706115"] },
          { colorNumber: 79, colorName: "GREEN×ICE GREEN", colorCode: "#C4E1C5", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_79.jpg?v=1686706115"] },
          { colorNumber: 8, colorName: "BLACK×LIGHT GRAY", colorCode: "#CEC9BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF372_08.jpg?v=1686706115"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf372",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "RELEASE-T 2",
        productNumber: "HP33JK203",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_01_a.jpg?v=1686207852",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#ECECEC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_01_a.jpg?v=1686207852"] },
          { colorNumber: 22, colorName: "PINK", colorCode: "#EFC5CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_22_a.jpg?v=1686207854"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5F5E46", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_65_a.jpg?v=1686207853"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#242A37", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_75_a.jpg?v=1686207852"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk203",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "RELEASE-T 2",
        productNumber: "HP33JK203",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_22_a.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#ECECEC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_01_a.jpg?v=1686207852"] },
          { colorNumber: 22, colorName: "PINK", colorCode: "#EFC5CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_22_a.jpg?v=1686207854"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5F5E46", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_65_a.jpg?v=1686207853"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#242A37", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_75_a.jpg?v=1686207852"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk203",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "RELEASE-T 2",
        productNumber: "HP33JK203",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_65_a.jpg?v=1686207853",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#ECECEC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_01_a.jpg?v=1686207852"] },
          { colorNumber: 22, colorName: "PINK", colorCode: "#EFC5CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_22_a.jpg?v=1686207854"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5F5E46", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_65_a.jpg?v=1686207853"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#242A37", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_75_a.jpg?v=1686207852"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk203",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "RELEASE-T 2",
        productNumber: "HP33JK203",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_75_a.jpg?v=1686207852",
        defaultImage: 4,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#ECECEC", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_01_a.jpg?v=1686207852"] },
          { colorNumber: 22, colorName: "PINK", colorCode: "#EFC5CA", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_22_a.jpg?v=1686207854"] },
          { colorNumber: 65, colorName: "KHAKI", colorCode: "#5F5E46", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_65_a.jpg?v=1686207853"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#242A37", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK203_75_a.jpg?v=1686207852"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk203",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "TWEED PLEATS",
        productNumber: "HP33FE321",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE321_41.jpg?v=1686310488",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#ACA99A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE321_41.jpg?v=1686310488"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#351500", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE321_44.jpg?v=1686310488"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fe321",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "TWEED PLEATS",
        productNumber: "HP33FE321",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE321_44.jpg?v=1686310488",
        defaultImage: 2,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#ACA99A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE321_41.jpg?v=1686310488"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#351500", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE321_44.jpg?v=1686310488"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fe321",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "TWEED PLEATS",
        productNumber: "HP33FF322",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF322_41.jpg?v=1686635315",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#ACA99A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF322_41.jpg?v=1686635315"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#351500", colorImages: [] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff322",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "NOVEMBER",
        name: "PACKABLE SHIRT",
        productNumber: "HP33FJ325",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_01_a.jpg?v=1686207852",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F3F1F0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_01_a.jpg?v=1686207852"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#F1D26E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_52_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2C2C2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_15_a.jpg?v=1686207853"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj325",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "NOVEMBER",
        name: "PACKABLE SHIRT",
        productNumber: "HP33FJ325",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_52_a.jpg?v=1686207853",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F3F1F0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_01_a.jpg?v=1686207852"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#F1D26E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_52_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2C2C2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_15_a.jpg?v=1686207853"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj325",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "PACKABLE SHIRT",
        productNumber: "HP33FJ325",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_15_a.jpg?v=1686207853",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F3F1F0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_01_a.jpg?v=1686207852"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#F1D26E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_52_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2C2C2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ325_15_a.jpg?v=1686207853"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj325",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "PACKABLE SHIRT",
        productNumber: "HP33FJ326",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_01_a.jpg?v=1686207853",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F3F1F0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_01_a.jpg?v=1686207853"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#F1D26E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_52_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2C2C2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_15_a.jpg?v=1686207852"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj326",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "NOVEMBER",
        name: "PACKABLE SHIRT",
        productNumber: "HP33FJ326",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_52_a.jpg?v=1686207853",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F3F1F0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_01_a.jpg?v=1686207853"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#F1D26E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_52_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2C2C2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_15_a.jpg?v=1686207852"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj326",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "PACKABLE SHIRT",
        productNumber: "HP33FJ326",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_15_a.jpg?v=1686207852",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F3F1F0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_01_a.jpg?v=1686207853"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#F1D26E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_52_a.jpg?v=1686207853"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2C2C2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FJ326_15_a.jpg?v=1686207852"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fj326",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AD409",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_41.jpg?v=1686207853",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_41.jpg?v=1686207853"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_52.jpg?v=1686207854"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_62.jpg?v=1686207854"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_15.jpg?v=1686207853"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ad409",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AD409",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_52.jpg?v=1686207854",
        defaultImage: 2,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_41.jpg?v=1686207853"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_52.jpg?v=1686207854"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_62.jpg?v=1686207854"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_15.jpg?v=1686207853"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ad409",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AD409",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_62.jpg?v=1686207854",
        defaultImage: 3,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_41.jpg?v=1686207853"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_52.jpg?v=1686207854"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_62.jpg?v=1686207854"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_15.jpg?v=1686207853"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ad409",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AD409",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_15.jpg?v=1686207853",
        defaultImage: 4,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_41.jpg?v=1686207853"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_52.jpg?v=1686207854"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_62.jpg?v=1686207854"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AD409_15.jpg?v=1686207853"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ad409",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AF406",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_41.jpg?v=1686302179",
        defaultImage: 1,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_41.jpg?v=1686302179"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_52.jpg?v=1686302179"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_62.jpg?v=1686302179"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_15.jpg?v=1686302179"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33af406",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AF406",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_52.jpg?v=1686302179",
        defaultImage: 2,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_41.jpg?v=1686302179"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_52.jpg?v=1686302179"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_62.jpg?v=1686302179"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_15.jpg?v=1686302179"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33af406",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AF406",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_62.jpg?v=1686302179",
        defaultImage: 3,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_41.jpg?v=1686302179"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_52.jpg?v=1686302179"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_62.jpg?v=1686302179"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_15.jpg?v=1686302179"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33af406",
        layout: ""
      },
      {
        category: "NOVEMBER",
        name: "FRAME AND BLOCKS",
        productNumber: "HP33AF406",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_15.jpg?v=1686302179",
        defaultImage: 4,
        colors: [
          { colorNumber: 41, colorName: "IVORY", colorCode: "#CDBFA6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_41.jpg?v=1686302179"] },
          { colorNumber: 52, colorName: "YELLOW", colorCode: "#E5CD31", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_52.jpg?v=1686302179"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#229043", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_62.jpg?v=1686302179"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#080506", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33AF406_15.jpg?v=1686302179"] }
        ],
        size: "-",
        release: "",
        ecSiteUpDate: "2023-10-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33af406",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JA126",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_64_a.jpg?v=1686207878",
        defaultImage: 1,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_64_a.jpg?v=1686207878"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_76_a.jpg?v=1686207878"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_47_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_15_a.jpg?v=1686207877"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja126",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JA126",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_76_a.jpg?v=1686207878",
        defaultImage: 2,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_64_a.jpg?v=1686207878"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_76_a.jpg?v=1686207878"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_47_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_15_a.jpg?v=1686207877"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja126",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JA126",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_47_a.jpg?v=1686207877",
        defaultImage: 3,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_64_a.jpg?v=1686207878"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_76_a.jpg?v=1686207878"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_47_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_15_a.jpg?v=1686207877"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja126",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JA126",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_15_a.jpg?v=1686207877",
        defaultImage: 4,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_64_a.jpg?v=1686207878"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_76_a.jpg?v=1686207878"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_47_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JA126_15_a.jpg?v=1686207877"] }
        ],
        size: "01,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ja126",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JK127",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_64_a.jpg?v=1686207877",
        defaultImage: 1,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_64_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_76_a.jpg?v=1686207877"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_47_a.jpg?v=1686207876"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_15_a.jpg?v=1686207877"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk127",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JK127",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_76_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_64_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_76_a.jpg?v=1686207877"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_47_a.jpg?v=1686207876"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_15_a.jpg?v=1686207877"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk127",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JK127",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_47_a.jpg?v=1686207876",
        defaultImage: 3,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_64_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_76_a.jpg?v=1686207877"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_47_a.jpg?v=1686207876"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_15_a.jpg?v=1686207877"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk127",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JK127",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_15_a.jpg?v=1686207877",
        defaultImage: 4,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_64_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_76_a.jpg?v=1686207877"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_47_a.jpg?v=1686207876"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#070707", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK127_15_a.jpg?v=1686207877"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk127",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JF128",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_64_a.jpg?v=1686207876",
        defaultImage: 1,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_64_a.jpg?v=1686207876"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_76_a.jpg?v=1686207876"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_47_a.jpg?v=1686207875"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf128",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JF128",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_76_a.jpg?v=1686207876",
        defaultImage: 2,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_64_a.jpg?v=1686207876"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_76_a.jpg?v=1686207876"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_47_a.jpg?v=1686207875"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf128",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "MC DECEMBER",
        productNumber: "HP33JF128",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_47_a.jpg?v=1686207875",
        defaultImage: 3,
        colors: [
          { colorNumber: 64, colorName: "GREEN TEA", colorCode: "#71802E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_64_a.jpg?v=1686207876"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3B5075", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_76_a.jpg?v=1686207876"] },
          { colorNumber: 47, colorName: "BURNT BROWN", colorCode: "#463839", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF128_47_a.jpg?v=1686207875"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf128",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "GRAPH PAPER",
        productNumber: "HP33JD360",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD360_01_a.jpg?v=1686207878",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#EFEEE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD360_01_a.jpg?v=1686207878"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2F2B2E", colorImages: [] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd360",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "DECEMBER",
        name: "GRAPH PAPER",
        productNumber: "HP33JE361",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE361_15_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#EFEEE6", colorImages: [] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2F2B2E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE361_15_a.jpg?v=1686207877"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je361",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "DECEMBER",
        name: "GRAPH PAPER",
        productNumber: "HP33JF362",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF362_01_a.jpg?v=1686207878",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#EFEEE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF362_01_a.jpg?v=1686207878"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2F2B2E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF362_15_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf362",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "DECEMBER",
        name: "GRAPH PAPER",
        productNumber: "HP33JF362",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF362_15_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#EFEEE6", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF362_01_a.jpg?v=1686207878"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#2F2B2E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF362_15_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf362",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JD385",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_11_a.jpg?v=1686207877",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_11_a.jpg?v=1686207877"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_28_a.jpg?v=1686207878"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_76_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd385",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JD385",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_28_a.jpg?v=1686207878",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_11_a.jpg?v=1686207877"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_28_a.jpg?v=1686207878"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_76_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd385",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JD385",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_76_a.jpg?v=1686207877",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_11_a.jpg?v=1686207877"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_28_a.jpg?v=1686207878"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD385_76_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd385",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JD386",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_11_a.jpg?v=1686207876",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_11_a.jpg?v=1686207876"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_28_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_76_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd386",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JD386",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_28_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_11_a.jpg?v=1686207876"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_28_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_76_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd386",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JD386",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_76_a.jpg?v=1686207877",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_11_a.jpg?v=1686207876"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_28_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD386_76_a.jpg?v=1686207877"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd386",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JF387",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_11_a.jpg?v=1686207875",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_11_a.jpg?v=1686207875"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_28_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_76_a.jpg?v=1686207876"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf387",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JF387",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_28_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_11_a.jpg?v=1686207875"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_28_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_76_a.jpg?v=1686207876"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf387",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "COLOR BLOCK",
        productNumber: "HP33JF387",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_76_a.jpg?v=1686207876",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#DADCDE", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_11_a.jpg?v=1686207875"] },
          { colorNumber: 28, colorName: "DRY RED", colorCode: "#DF423E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_28_a.jpg?v=1686207877"] },
          { colorNumber: 76, colorName: "STORMY BLUE", colorCode: "#3D537D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF387_76_a.jpg?v=1686207876"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf387",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "HEATHER PLEATS",
        productNumber: "HP33JC170",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_12_a.jpg?v=1686207877",
        defaultImage: 1,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_12_a.jpg?v=1686207877"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#38395A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_72_a.jpg?v=1686207877"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#563F3E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_44_a.jpg?v=1686207877"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc170",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "HEATHER PLEATS",
        productNumber: "HP33JC170",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_72_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_12_a.jpg?v=1686207877"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#38395A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_72_a.jpg?v=1686207877"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#563F3E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_44_a.jpg?v=1686207877"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc170",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "HEATHER PLEATS",
        productNumber: "HP33JC170",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_44_a.jpg?v=1686207877",
        defaultImage: 3,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_12_a.jpg?v=1686207877"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#38395A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_72_a.jpg?v=1686207877"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#563F3E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JC170_44_a.jpg?v=1686207877"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jc170",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "HEATHER PLEATS",
        productNumber: "HP33JK171",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_12_a.jpg?v=1686207877",
        defaultImage: 1,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_12_a.jpg?v=1686207877"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#38395A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_72_a.jpg?v=1686207877"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#563F3E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_44_a.jpg?v=1686207877"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk171",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "HEATHER PLEATS",
        productNumber: "HP33JK171",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_72_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_12_a.jpg?v=1686207877"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#38395A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_72_a.jpg?v=1686207877"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#563F3E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_44_a.jpg?v=1686207877"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk171",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "HEATHER PLEATS",
        productNumber: "HP33JK171",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_44_a.jpg?v=1686207877",
        defaultImage: 3,
        colors: [
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_12_a.jpg?v=1686207877"] },
          { colorNumber: 72, colorName: "BLUE", colorCode: "#38395A", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_72_a.jpg?v=1686207877"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#563F3E", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK171_44_a.jpg?v=1686207877"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk171",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF140",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_34_a.jpg?v=1686207877",
        defaultImage: 1,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_66_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_15_a.jpg?v=1686207876"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf140",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF140",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_66_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_66_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_15_a.jpg?v=1686207876"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf140",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF140",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_15_a.jpg?v=1686207876",
        defaultImage: 3,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_66_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF140_15_a.jpg?v=1686207876"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf140",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF141",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_34_a.jpg?v=1686207877",
        defaultImage: 1,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_66_a.jpg?v=1686207876"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_15_a.jpg?v=1686207876"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf141",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF141",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_66_a.jpg?v=1686207876",
        defaultImage: 2,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_66_a.jpg?v=1686207876"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_15_a.jpg?v=1686207876"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf141",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF141",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_15_a.jpg?v=1686207876",
        defaultImage: 3,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_66_a.jpg?v=1686207876"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF141_15_a.jpg?v=1686207876"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf141",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF142",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_34_a.jpg?v=1686207877",
        defaultImage: 1,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_66_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_15_a.jpg?v=1686207874"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf142",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF142",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_66_a.jpg?v=1686207877",
        defaultImage: 2,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_66_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_15_a.jpg?v=1686207874"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf142",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PLEATS BOTTOMS 2",
        productNumber: "HP33JF142",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_15_a.jpg?v=1686207874",
        defaultImage: 3,
        colors: [
          { colorNumber: 34, colorName: "FIRE ORANGE", colorCode: "#B72B2C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_34_a.jpg?v=1686207877"] },
          { colorNumber: 66, colorName: "MOSS KHAKI", colorCode: "#60623C", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_66_a.jpg?v=1686207877"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#060606", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF142_15_a.jpg?v=1686207874"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf142",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PADDED PLEATS",
        productNumber: "HP33FC317",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC317_44.jpg?v=1686310488",
        defaultImage: 3,
        colors: [
          { colorNumber: 72, colorName: "BLUE", colorCode: "#E2E1E9", colorImages: [] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93C4BD", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#524B42", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FC317_44.jpg?v=1686310488"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fc317",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "DECEMBER",
        name: "PADDED PLEATS",
        productNumber: "HP33FE319",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE319_72.jpg?v=1686310488",
        defaultImage: 1,
        colors: [
          { colorNumber: 72, colorName: "BLUE", colorCode: "#E2E1E9", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE319_72.jpg?v=1686310488"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93C4BD", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#524B42", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE319_44.jpg?v=1686310488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fe319",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "DECEMBER",
        name: "PADDED PLEATS",
        productNumber: "HP33FE319",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE319_44.jpg?v=1686310488",
        defaultImage: 3,
        colors: [
          { colorNumber: 72, colorName: "BLUE", colorCode: "#E2E1E9", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE319_72.jpg?v=1686310488"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93C4BD", colorImages: [] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#524B42", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FE319_44.jpg?v=1686310488"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33fe319",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PADDED PLEATS",
        productNumber: "HP33FF318",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_72.jpg?v=1686625006",
        defaultImage: 1,
        colors: [
          { colorNumber: 72, colorName: "BLUE", colorCode: "#E2E1E9", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_72.jpg?v=1686625006"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93C4BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_62.jpg?v=1686624975"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#524B42", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_44.jpg?v=1686634837"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff318",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "DECEMBER",
        name: "PADDED PLEATS",
        productNumber: "HP33FF318",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_62.jpg?v=1686624975",
        defaultImage: 2,
        colors: [
          { colorNumber: 72, colorName: "BLUE", colorCode: "#E2E1E9", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_72.jpg?v=1686625006"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93C4BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_62.jpg?v=1686624975"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#524B42", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_44.jpg?v=1686634837"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff318",
        layout: ""
      },
      {
        category: "DECEMBER",
        name: "PADDED PLEATS",
        productNumber: "HP33FF318",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_44.jpg?v=1686634837",
        defaultImage: 3,
        colors: [
          { colorNumber: 72, colorName: "BLUE", colorCode: "#E2E1E9", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_72.jpg?v=1686625006"] },
          { colorNumber: 62, colorName: "GREEN", colorCode: "#93C4BD", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_62.jpg?v=1686624975"] },
          { colorNumber: 44, colorName: "BROWN", colorCode: "#524B42", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33FF318_44.jpg?v=1686634837"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-11-30T15:00:00.000Z",
        onlineStoreLink: "/products/hp33ff318",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JD401",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd401",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JD401",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd401",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JD401",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD401_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd401",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JD402",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd402",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JD402",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd402",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JD402",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JD402_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jd402",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE410",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je410",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE410",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je410",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE410",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je410",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE411",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je411",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE411",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je411",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE411",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je411",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK420",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk420",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK420",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk420",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK420",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk420",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK421",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk421",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK421",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk421",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK421",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk421",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK422",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk422",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK422",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk422",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK422",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk422",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL440",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl440",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL440",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl440",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL440",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl440",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL441",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl441",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL441",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl441",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL441",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl441",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JM430",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm430",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JM430",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm430",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JM430",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103"] }
        ],
        size: "02,03,04",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm430",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF450",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf450",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF450",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf450",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF450",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf450",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF451",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf451",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF451",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf451",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF451",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103"] }
        ],
        size: "01,02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf451",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF453",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_15.jpg?v=1686208103"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf453",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF453",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_15.jpg?v=1686208103"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf453",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF453",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_15.jpg?v=1686208103"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf453",
        layout: ""
      },
      {
        category: "BASICS",
        name: "RELEASE-T BASIC",
        productNumber: "HP55JK310",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686880297",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F1F2ED", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686880297"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#B0B0B0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686880297"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0D0D0D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686880297"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp38jk210",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "RELEASE-T BASIC",
        productNumber: "HP55JK310",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686880297",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F1F2ED", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686880297"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#B0B0B0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686880297"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0D0D0D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686880297"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp38jk210",
        layout: ""
      },
      {
        category: "BASICS",
        name: "RELEASE-T BASIC",
        productNumber: "HP55JK310",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686880297",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F1F2ED", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686880297"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#B0B0B0", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686880297"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0D0D0D", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686880297"] }
        ],
        size: "02,03",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp38jk210",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE410",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je410",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE410",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je410",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE410",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_11.jpg?v=1686208102"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE410_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je410",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE411",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je411",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE411",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je411",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JE411",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JE411_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33je411",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK420",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk420",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK420",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk420",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK420",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK420_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk420",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK421",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk421",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK421",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk421",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK421",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK421_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk421",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK422",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk422",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK422",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk422",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JK422",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK422_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jk422",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL440",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl440",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL440",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl440",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL440",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL440_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl440",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL441",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl441",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL441",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl441",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JL441",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JL441_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jl441",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JM430",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm430",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JM430",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm430",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JM430",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JM430_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jm430",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF450",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf450",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF450",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf450",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF450",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF450_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf450",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF451",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf451",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF451",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf451",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF451",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF451_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf451",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF453",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103",
        defaultImage: 1,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf453",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF453",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103",
        defaultImage: 2,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_15.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf453",
        layout: ""
      },
      {
        category: "BASICS",
        name: "BASICS",
        productNumber: "HP33JF453",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103",
        defaultImage: 3,
        colors: [
          { colorNumber: 11, colorName: "LIGHT GRAY", colorCode: "#E6E5E1", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_11.jpg?v=1686208103"] },
          { colorNumber: 75, colorName: "NAVY", colorCode: "#0A0024", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JF453_75.jpg?v=1686208103"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp33jf453",
        layout: ""
      },
      {
        category: "BASICS",
        name: "RELEASE-T BASIC",
        productNumber: "HP38JK210",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686208985",
        defaultImage: 1,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F1F2ED", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686208985"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686208986"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686208985"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp38jk210",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "BASICS",
        name: "RELEASE-T BASIC",
        productNumber: "HP38JK210",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686208986",
        defaultImage: 2,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F1F2ED", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686208985"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686208986"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686208985"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp38jk210",
        layout: ""
      },
      {
        category: "BASICS",
        name: "RELEASE-T BASIC",
        productNumber: "HP38JK210",
        listImage: "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686208985",
        defaultImage: 3,
        colors: [
          { colorNumber: 1, colorName: "WHITE", colorCode: "#F1F2ED", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_01.jpg?v=1686208985"] },
          { colorNumber: 12, colorName: "GRAY", colorCode: "#747377", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_12.jpg?v=1686208986"] },
          { colorNumber: 15, colorName: "BLACK", colorCode: "#0E0E10", colorImages: ["https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP33JK200_15.jpg?v=1686208985"] }
        ],
        size: "",
        release: "",
        ecSiteUpDate: "2023-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/hp38jk210",
        layout: ""
      }
    ];*/
    /*this.json = [
      {
        category: "BASICS ",
        name: "LUCENT & THE LONGNAME ITEM",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01.jpg?v=1692940281",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15.jpg?v=1692940281",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40.jpg?v=1692940281",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91.jpg?v=1692940281",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01.jpg?v=1692940281",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15.jpg?v=1692940281",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40.jpg?v=1692940281",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91.jpg?v=1692940281",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_b687885a-482f-4b25-8ceb-6189573d43d7.jpg?v=1692953136",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_b687885a-482f-4b25-8ceb-6189573d43d7.jpg?v=1692953136"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15.jpg?v=1692940281",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_b687885a-482f-4b25-8ceb-6189573d43d7.jpg?v=1692953136"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40.jpg?v=1692940281",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_b687885a-482f-4b25-8ceb-6189573d43d7.jpg?v=1692953136"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91.jpg?v=1692940281",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_b687885a-482f-4b25-8ceb-6189573d43d7.jpg?v=1692953136"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01.jpg?v=1692940281",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15.jpg?v=1692940281",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40.jpg?v=1692940281",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91.jpg?v=1692940281",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01.jpg?v=1692940281",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15.jpg?v=1692940281",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40.jpg?v=1692940281",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91.jpg?v=1692940281",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01.jpg?v=1692940281",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15.jpg?v=1692940281",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40.jpg?v=1692940281",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91.jpg?v=1692940281",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01.jpg?v=1692940281"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15.jpg?v=1692940281"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40.jpg?v=1692940281"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91.jpg?v=1692940281"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS ",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_60px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_60px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_60px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_60px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_60px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_60px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_60px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_60px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_60px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_60px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_60px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_60px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_60px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_60px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_60px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_60px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_60px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_60px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_60px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_60px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_60px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_60px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_60px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_60px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_60px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_60px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_60px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_60px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 2",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_180px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_180px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_180px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_180px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_180px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_180px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_180px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_180px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_180px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_180px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_180px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_180px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_180px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_180px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_180px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_180px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_180px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_180px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_180px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_180px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_180px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_180px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_180px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_180px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_180px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_180px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_180px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_180px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 3",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_280px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_280px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_280px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG053",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_280px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG053_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag053",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_280px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_280px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_280px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG054",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_280px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG054_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag054",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_280px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_280px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_280px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG056",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_280px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG056_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag056",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_280px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_280px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_280px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "LUCENT",
        productNumber: "AG055",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_280px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG055_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag055",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_280px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_280px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_280px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG043",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_280px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG043_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag043",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_280px.jpg",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_280px.jpg",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_280px.jpg",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG047",
        listImage: "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_280px.jpg",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_01_280px.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_15_280px.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_40_280px.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB41AG047_91_280px.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag047",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "BASICS 4",
        name: "PRISM",
        productNumber: "AG045",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG045_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG045_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG045_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG045_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag045",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CONNECT",
        productNumber: "AG802",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#EEEEF0",
            colorImages: ["BB41AG802_17.jpg"]
          },
          {
            colorNumber: 27,
            colorName: "RED x ICE BLUE",
            colorCode: "#DEFA71",
            colorImages: ["BB41AG802_27.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E20624",
            colorImages: ["BB41AG802_57.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag802",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CONNECT",
        productNumber: "AG802",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#EEEEF0",
            colorImages: ["BB41AG802_17.jpg"]
          },
          {
            colorNumber: 27,
            colorName: "RED x ICE BLUE",
            colorCode: "#DEFA71",
            colorImages: ["BB41AG802_27.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E20624",
            colorImages: ["BB41AG802_57.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag802",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CONNECT",
        productNumber: "AG802",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#EEEEF0",
            colorImages: ["BB41AG802_17.jpg"]
          },
          {
            colorNumber: 27,
            colorName: "RED x ICE BLUE",
            colorCode: "#DEFA71",
            colorImages: ["BB41AG802_27.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E20624",
            colorImages: ["BB41AG802_57.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag802",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CONNECT",
        productNumber: "AG801",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#EEEEF0",
            colorImages: ["BB41AG801_17.jpg"]
          },
          {
            colorNumber: 27,
            colorName: "RED x ICE BLUE",
            colorCode: "#DEFA71",
            colorImages: ["BB41AG801_27.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E20624",
            colorImages: ["BB41AG801_57.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag801",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CONNECT",
        productNumber: "AG801",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#EEEEF0",
            colorImages: ["BB41AG801_17.jpg"]
          },
          {
            colorNumber: 27,
            colorName: "RED x ICE BLUE",
            colorCode: "#DEFA71",
            colorImages: ["BB41AG801_27.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E20624",
            colorImages: ["BB41AG801_57.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag801",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CONNECT",
        productNumber: "AG801",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#EEEEF0",
            colorImages: ["BB41AG801_17.jpg"]
          },
          {
            colorNumber: 27,
            colorName: "RED x ICE BLUE",
            colorCode: "#DEFA71",
            colorImages: ["BB41AG801_27.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E20624",
            colorImages: ["BB41AG801_57.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag801",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG652",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG652_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG652_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG652_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG652_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG652_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG652_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag652",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG652",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG652_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG652_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG652_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG652_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG652_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG652_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag652",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG652",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG652_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG652_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG652_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG652_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG652_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG652_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag652",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG652",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG652_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG652_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG652_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG652_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG652_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG652_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag652",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG652",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG652_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG652_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG652_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG652_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG652_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG652_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag652",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG652",
        listImage: "",
        defaultImage: 6,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG652_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG652_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG652_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG652_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG652_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG652_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag652",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG651",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG651_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG651_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG651_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG651_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG651_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG651_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag651",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG651",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG651_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG651_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG651_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG651_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG651_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG651_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag651",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG651",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG651_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG651_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG651_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG651_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG651_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG651_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag651",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG651",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG651_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG651_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG651_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG651_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG651_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG651_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag651",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG651",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG651_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG651_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG651_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG651_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG651_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG651_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag651",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LUCENT BOXY",
        productNumber: "AG651",
        listImage: "",
        defaultImage: 6,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#D6B8BA",
            colorImages: ["BB41AG651_22.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#D4AD9C",
            colorImages: ["BB41AG651_32.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#C4C790",
            colorImages: ["BB41AG651_61.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#313131",
            colorImages: ["BB41AG651_71.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#ABA29B",
            colorImages: ["BB41AG651_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#2C2C2C",
            colorImages: ["BB41AG651_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag651",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG503",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG503_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG503_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG503_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag503",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG503",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG503_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG503_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG503_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag503",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG503",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG503_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG503_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG503_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag503",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG507",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG507_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG507_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG507_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag507",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG507",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG507_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG507_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG507_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag507",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG507",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG507_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG507_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG507_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag507",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG506",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG506_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG506_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG506_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag506",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG506",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG506_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG506_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG506_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag506",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "PRISM MATTE",
        productNumber: "AG506",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D7D3D3",
            colorImages: ["BB41AG506_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#564C4C",
            colorImages: ["BB41AG506_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG506_16.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag506",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LOOP METALLIC",
        productNumber: "AG571",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 31,
            colorName: "COPPER",
            colorCode: "#A49087",
            colorImages: ["BB41AG571_31.jpg"]
          },
          {
            colorNumber: 82,
            colorName: "LIGHT PURPLE",
            colorCode: "#AB9ABC",
            colorImages: ["BB41AG571_82.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#313131",
            colorImages: ["BB41AG571_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag571",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "LOOP METALLIC",
        productNumber: "AG571",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 31,
            colorName: "COPPER",
            colorCode: "#A49087",
            colorImages: ["BB41AG571_31.jpg"]
          },
          {
            colorNumber: 82,
            colorName: "LIGHT PURPLE",
            colorCode: "#AB9ABC",
            colorImages: ["BB41AG571_82.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#313131",
            colorImages: ["BB41AG571_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag571",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "LOOP METALLIC",
        productNumber: "AG571",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 31,
            colorName: "COPPER",
            colorCode: "#A49087",
            colorImages: ["BB41AG571_31.jpg"]
          },
          {
            colorNumber: 82,
            colorName: "LIGHT PURPLE",
            colorCode: "#AB9ABC",
            colorImages: ["BB41AG571_82.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#313131",
            colorImages: ["BB41AG571_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag571",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CARTON",
        productNumber: "AG421",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG421_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG421_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG421_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag421",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CARTON",
        productNumber: "AG421",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG421_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG421_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG421_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag421",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CARTON",
        productNumber: "AG421",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG421_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG421_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG421_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag421",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CARTON",
        productNumber: "AG422",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG422_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG422_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG422_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag422",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CARTON",
        productNumber: "AG422",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG422_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG422_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG422_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag422",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CARTON",
        productNumber: "AG422",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG422_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG422_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG422_91.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag422",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG311",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG311_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG311_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG311_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag311",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG311",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG311_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG311_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG311_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag311",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG311",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG311_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG311_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG311_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag311",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG313",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG313_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG313_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG313_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag313",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG313",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG313_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG313_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG313_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag313",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG313",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG313_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG313_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG313_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag313",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG314",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG314_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG314_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG314_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag314",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG314",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG314_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG314_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG314_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag314",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CRYSTAL MATTE",
        productNumber: "AG314",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#313131",
            colorImages: ["BB41AG314_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#DCC6BB",
            colorImages: ["BB41AG314_42.jpg"]
          },
          {
            colorNumber: 70,
            colorName: "ICE BLUE",
            colorCode: "#B0BCD4",
            colorImages: ["BB41AG314_70.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag314",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CARD CASE METALLIC",
        productNumber: "AG751",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 31,
            colorName: "COPPER",
            colorCode: "#A49087",
            colorImages: ["BB41AG751_31.jpg"]
          },
          {
            colorNumber: 82,
            colorName: "LIGHT PURPLE",
            colorCode: "#AB9ABC",
            colorImages: ["BB41AG751_82.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#313131",
            colorImages: ["BB41AG751_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag751",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JANUARY",
        name: "CARD CASE METALLIC",
        productNumber: "AG751",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 31,
            colorName: "COPPER",
            colorCode: "#A49087",
            colorImages: ["BB41AG751_31.jpg"]
          },
          {
            colorNumber: 82,
            colorName: "LIGHT PURPLE",
            colorCode: "#AB9ABC",
            colorImages: ["BB41AG751_82.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#313131",
            colorImages: ["BB41AG751_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag751",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CARD CASE METALLIC",
        productNumber: "AG751",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 31,
            colorName: "COPPER",
            colorCode: "#A49087",
            colorImages: ["BB41AG751_31.jpg"]
          },
          {
            colorNumber: 82,
            colorName: "LIGHT PURPLE",
            colorCode: "#AB9ABC",
            colorImages: ["BB41AG751_82.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#313131",
            colorImages: ["BB41AG751_94.jpg"]
          }
        ],
        size: "-",
        release: "1月上旬",
        ecSiteUpDate: "2023-12-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag751",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "HIKER",
        productNumber: "AG001",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG001_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag001",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "JANUARY",
        name: "LINER",
        productNumber: "AG111",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG111_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag111",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JANUARY",
        name: "LINER",
        productNumber: "AG112",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#CDDAD3",
            colorImages: ["BB42AG112_11.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag112",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "DAYPACK",
        productNumber: "AG031",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG031_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag031",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JANUARY",
        name: "DAYPACK",
        productNumber: "AG032",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#CDDAD3",
            colorImages: ["BB42AG032_11.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag032",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CART",
        productNumber: "AG161",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG161_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag161",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "JANUARY",
        name: "CART S",
        productNumber: "AG261",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG261_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag261",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JANUARY",
        name: "CART S",
        productNumber: "AG262",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#CDDAD3",
            colorImages: ["BB42AG262_11.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag262",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "FROGGY",
        productNumber: "AG171",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG171_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag171",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "JANUARY",
        name: "SADDLE BAG",
        productNumber: "AG131",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG131_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag131",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JANUARY",
        name: "SADDLE BAG",
        productNumber: "AG132",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#CDDAD3",
            colorImages: ["BB42AG132_11.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag132",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "VOYAGER",
        productNumber: "AG121",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG121_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag121",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JANUARY",
        name: "VOYAGER",
        productNumber: "AG122",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#CDDAD3",
            colorImages: ["BB42AG122_11.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag122",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "BEETLE",
        productNumber: "AG341",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG341_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag341",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JANUARY",
        name: "BEETLE",
        productNumber: "AG342",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#CDDAD3",
            colorImages: ["BB42AG342_11.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag342",
        layout: ""
      },
      {
        category: "JANUARY",
        name: "CLAM WALLET",
        productNumber: "AG331",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG331_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag331",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "JANUARY",
        name: "OYSTER",
        productNumber: "AG321",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#121212",
            colorImages: ["BB42AG321_16.jpg"]
          }
        ],
        size: "-",
        release: "1月中旬",
        ecSiteUpDate: "2024-01-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag321",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG172",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG172_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG172_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG172_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag172",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG172",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG172_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG172_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG172_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag172",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG172",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG172_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG172_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG172_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag172",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG171",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG171_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG171_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG171_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag171",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG171",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG171_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG171_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG171_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag171",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG171",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG171_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG171_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG171_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag171",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG173",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG173_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG173_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG173_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag173",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG173",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG173_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG173_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG173_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag173",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PLATINUM COFFRET",
        productNumber: "AG173",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 23,
            colorName: "ROSE PINK",
            colorCode: "#EECEC3",
            colorImages: ["BB41AG173_23.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#D4D3CE",
            colorImages: ["BB41AG173_91.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B7A79A",
            colorImages: ["BB41AG173_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag173",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CUBOID",
        productNumber: "AG661",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG661_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#878181",
            colorImages: ["BB41AG661_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG661_16.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9EB2D7",
            colorImages: ["BB41AG661_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag661",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "CUBOID",
        productNumber: "AG661",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG661_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#878181",
            colorImages: ["BB41AG661_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG661_16.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9EB2D7",
            colorImages: ["BB41AG661_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag661",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CUBOID",
        productNumber: "AG661",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG661_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#878181",
            colorImages: ["BB41AG661_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG661_16.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9EB2D7",
            colorImages: ["BB41AG661_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag661",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CUBOID",
        productNumber: "AG661",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG661_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#878181",
            colorImages: ["BB41AG661_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#232323",
            colorImages: ["BB41AG661_16.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9EB2D7",
            colorImages: ["BB41AG661_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag661",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PRISM METALLIC",
        productNumber: "AG513",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#B58680",
            colorImages: ["BB41AG513_20.jpg"]
          },
          {
            colorNumber: 83,
            colorName: "LILAC",
            colorCode: "#AA8BA3",
            colorImages: ["BB41AG513_83.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#6A6957",
            colorImages: ["BB41AG513_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag513",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "PRISM METALLIC",
        productNumber: "AG513",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#B58680",
            colorImages: ["BB41AG513_20.jpg"]
          },
          {
            colorNumber: 83,
            colorName: "LILAC",
            colorCode: "#AA8BA3",
            colorImages: ["BB41AG513_83.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#6A6957",
            colorImages: ["BB41AG513_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag513",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PRISM METALLIC",
        productNumber: "AG513",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#B58680",
            colorImages: ["BB41AG513_20.jpg"]
          },
          {
            colorNumber: 83,
            colorName: "LILAC",
            colorCode: "#AA8BA3",
            colorImages: ["BB41AG513_83.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#6A6957",
            colorImages: ["BB41AG513_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag513",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PRISM METALLIC",
        productNumber: "AG517",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#B58680",
            colorImages: ["BB41AG517_20.jpg"]
          },
          {
            colorNumber: 83,
            colorName: "LILAC",
            colorCode: "#AA8BA3",
            colorImages: ["BB41AG517_83.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#6A6957",
            colorImages: ["BB41AG517_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag517",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "PRISM METALLIC",
        productNumber: "AG517",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#B58680",
            colorImages: ["BB41AG517_20.jpg"]
          },
          {
            colorNumber: 83,
            colorName: "LILAC",
            colorCode: "#AA8BA3",
            colorImages: ["BB41AG517_83.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#6A6957",
            colorImages: ["BB41AG517_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag517",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "PRISM METALLIC",
        productNumber: "AG517",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#B58680",
            colorImages: ["BB41AG517_20.jpg"]
          },
          {
            colorNumber: 83,
            colorName: "LILAC",
            colorCode: "#AA8BA3",
            colorImages: ["BB41AG517_83.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#6A6957",
            colorImages: ["BB41AG517_94.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag517",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "WRING",
        productNumber: "AG531",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG531_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG531_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG531_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG531_91.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag531",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "WRING",
        productNumber: "AG531",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG531_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG531_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG531_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG531_91.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag531",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "WRING",
        productNumber: "AG531",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG531_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG531_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG531_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG531_91.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag531",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "WRING",
        productNumber: "AG531",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG531_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG531_15.jpg"]
          },
          {
            colorNumber: 40,
            colorName: "BEIGE",
            colorCode: "#E8D5C7",
            colorImages: ["BB41AG531_40.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG531_91.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag531",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "ROW METALLIC",
        productNumber: "AG462",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG462_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG462_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG462_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag462",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "ROW METALLIC",
        productNumber: "AG462",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG462_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG462_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG462_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag462",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "ROW METALLIC",
        productNumber: "AG462",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG462_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG462_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG462_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag462",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "ROW METALLIC",
        productNumber: "AG463",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG463_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG463_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG463_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag463",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "ROW METALLIC",
        productNumber: "AG463",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG463_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG463_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG463_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag463",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "ROW METALLIC",
        productNumber: "AG463",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG463_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG463_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG463_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag463",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG205",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG205_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG205_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG205_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag205",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG205",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG205_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG205_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG205_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag205",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG205",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG205_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG205_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG205_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag205",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG204",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG204_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG204_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG204_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag204",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG204",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG204_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG204_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG204_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag204",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG204",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG204_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG204_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG204_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag204",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG201",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG201_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG201_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG201_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag201",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG201",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG201_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG201_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG201_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag201",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "TONNEAU MATTE",
        productNumber: "AG201",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG201_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG201_16.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#BAC29D",
            colorImages: ["BB41AG201_61.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag201",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CARD CASE",
        productNumber: "AG711",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG711_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG711_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG711_91.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag711",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "CARD CASE",
        productNumber: "AG711",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG711_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG711_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG711_91.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag711",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CARD CASE",
        productNumber: "AG711",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#F7F7F7",
            colorImages: ["BB41AG711_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#000000",
            colorImages: ["BB41AG711_15.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#8A8A8A",
            colorImages: ["BB41AG711_91.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag711",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CARD WALLET",
        productNumber: "AG731",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG731_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG731_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG731_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag731",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "FEBRUARY",
        name: "CARD WALLET",
        productNumber: "AG731",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG731_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG731_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG731_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag731",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CARD WALLET",
        productNumber: "AG731",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 2,
            colorName: "IVORY",
            colorCode: "#DEDBD4",
            colorImages: ["BB41AG731_02.jpg"]
          },
          {
            colorNumber: 20,
            colorName: "PINK BEIGE",
            colorCode: "#BDA2A7",
            colorImages: ["BB41AG731_20.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#8DA7B6",
            colorImages: ["BB41AG731_71.jpg"]
          }
        ],
        size: "-",
        release: "2月上旬",
        ecSiteUpDate: "2024-01-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag731",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "DAYPACK",
        productNumber: "AG033",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG033_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG033_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag033",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "DAYPACK",
        productNumber: "AG033",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG033_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG033_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag033",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CART",
        productNumber: "AG163",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG163_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG163_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag163",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "CART",
        productNumber: "AG163",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG163_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG163_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag163",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "SADDLE BAG",
        productNumber: "AG133",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG133_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG133_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag133",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "SADDLE BAG",
        productNumber: "AG133",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG133_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG133_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag133",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "VOYAGER",
        productNumber: "AG123",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG123_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG123_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag123",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "VOYAGER",
        productNumber: "AG123",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#8DBC78",
            colorImages: ["BB42AG123_61.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#A09C9D",
            colorImages: ["BB42AG123_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag123",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "OYSTER METALLIC",
        productNumber: "AG821",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG821_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG821_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG821_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG821_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag821",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "OYSTER METALLIC",
        productNumber: "AG821",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG821_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG821_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG821_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG821_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag821",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "OYSTER METALLIC",
        productNumber: "AG821",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG821_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG821_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG821_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG821_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag821",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "OYSTER METALLIC",
        productNumber: "AG821",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG821_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG821_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG821_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG821_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag821",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CLAM WALLET METALLIC",
        productNumber: "AG831",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG831_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG831_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG831_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG831_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag831",
        layout: "type-4-2: PC4カラム・スマホ2カラム"
      },
      {
        category: "FEBRUARY",
        name: "CLAM WALLET METALLIC",
        productNumber: "AG831",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG831_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG831_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG831_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG831_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag831",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CLAM WALLET METALLIC",
        productNumber: "AG831",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG831_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG831_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG831_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG831_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag831",
        layout: ""
      },
      {
        category: "FEBRUARY",
        name: "CLAM WALLET METALLIC",
        productNumber: "AG831",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 22,
            colorName: "PINK",
            colorCode: "#B19186",
            colorImages: ["BB42AG831_22.jpg"]
          },
          {
            colorNumber: 61,
            colorName: "LIGHT GREEN",
            colorCode: "#9DC07C",
            colorImages: ["BB42AG831_61.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#80819D",
            colorImages: ["BB42AG831_72.jpg"]
          },
          {
            colorNumber: 94,
            colorName: "GUNMETAL",
            colorCode: "#B3AAA1",
            colorImages: ["BB42AG831_94.jpg"]
          }
        ],
        size: "-",
        release: "2月中旬",
        ecSiteUpDate: "2024-02-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag831",
        layout: ""
      },
      {
        category: "MARCH",
        name: "DUO",
        productNumber: "AG812",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#F5F1EE",
            colorImages: ["BB41AG812_17.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E4E452",
            colorImages: ["BB41AG812_57.jpg"]
          },
          {
            colorNumber: 87,
            colorName: "LAVENDER x BEIGE",
            colorCode: "#B2ACC4",
            colorImages: ["BB41AG812_87.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag812",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "DUO",
        productNumber: "AG812",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#F5F1EE",
            colorImages: ["BB41AG812_17.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E4E452",
            colorImages: ["BB41AG812_57.jpg"]
          },
          {
            colorNumber: 87,
            colorName: "LAVENDER x BEIGE",
            colorCode: "#B2ACC4",
            colorImages: ["BB41AG812_87.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag812",
        layout: ""
      },
      {
        category: "MARCH",
        name: "DUO",
        productNumber: "AG812",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#F5F1EE",
            colorImages: ["BB41AG812_17.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E4E452",
            colorImages: ["BB41AG812_57.jpg"]
          },
          {
            colorNumber: 87,
            colorName: "LAVENDER x BEIGE",
            colorCode: "#B2ACC4",
            colorImages: ["BB41AG812_87.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag812",
        layout: ""
      },
      {
        category: "MARCH",
        name: "DUO",
        productNumber: "AG811",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#F5F1EE",
            colorImages: ["BB41AG811_17.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E4E452",
            colorImages: ["BB41AG811_57.jpg"]
          },
          {
            colorNumber: 87,
            colorName: "LAVENDER x BEIGE",
            colorCode: "#B2ACC4",
            colorImages: ["BB41AG811_87.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag811",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "DUO",
        productNumber: "AG811",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#F5F1EE",
            colorImages: ["BB41AG811_17.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E4E452",
            colorImages: ["BB41AG811_57.jpg"]
          },
          {
            colorNumber: 87,
            colorName: "LAVENDER x BEIGE",
            colorCode: "#B2ACC4",
            colorImages: ["BB41AG811_87.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag811",
        layout: ""
      },
      {
        category: "MARCH",
        name: "DUO",
        productNumber: "AG811",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 17,
            colorName: "WHITE x BLACK",
            colorCode: "#F5F1EE",
            colorImages: ["BB41AG811_17.jpg"]
          },
          {
            colorNumber: 57,
            colorName: "YELLOW GREEN x GRAY",
            colorCode: "#E4E452",
            colorImages: ["BB41AG811_57.jpg"]
          },
          {
            colorNumber: 87,
            colorName: "LAVENDER x BEIGE",
            colorCode: "#B2ACC4",
            colorImages: ["BB41AG811_87.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag811",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG603",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG603_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG603_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG603_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG603_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG603_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag603",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG603",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG603_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG603_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG603_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG603_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG603_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag603",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG603",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG603_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG603_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG603_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG603_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG603_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag603",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG603",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG603_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG603_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG603_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG603_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG603_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag603",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG603",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG603_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG603_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG603_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG603_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG603_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag603",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG605",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG605_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG605_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG605_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG605_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG605_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag605",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG605",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG605_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG605_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG605_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG605_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG605_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag605",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG605",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG605_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG605_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG605_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG605_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG605_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag605",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG605",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG605_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG605_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG605_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG605_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG605_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag605",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "LUCENT GLOSS",
        productNumber: "AG605",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG605_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG605_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG605_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG605_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG605_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag605",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG682",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG682_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG682_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG682_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag682",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG682",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG682_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG682_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG682_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag682",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG682",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG682_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG682_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG682_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag682",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG683",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG683_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG683_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG683_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag683",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG683",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG683_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG683_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG683_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag683",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG683",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG683_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG683_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG683_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag683",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG687",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG687_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG687_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG687_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag687",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG687",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG687_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG687_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG687_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag687",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LUCENT MATTE",
        productNumber: "AG687",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG687_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG687_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG687_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag687",
        layout: ""
      },
      {
        category: "MARCH",
        name: "FLAT PACK",
        productNumber: "AG691",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG691_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG691_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG691_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag691",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "FLAT PACK",
        productNumber: "AG691",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG691_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG691_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG691_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag691",
        layout: ""
      },
      {
        category: "MARCH",
        name: "FLAT PACK",
        productNumber: "AG691",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG691_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG691_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG691_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag691",
        layout: ""
      },
      {
        category: "MARCH",
        name: "WRING ONE-TONE",
        productNumber: "AG591",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG591_11.jpg"]
          },
          {
            colorNumber: 13,
            colorName: "DARK GRAY",
            colorCode: "#B1A8A3",
            colorImages: ["BB41AG591_13.jpg"]
          },
          {
            colorNumber: 30,
            colorName: "APRICOT",
            colorCode: "#FEB58A",
            colorImages: ["BB41AG591_30.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag591",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "WRING ONE-TONE",
        productNumber: "AG591",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG591_11.jpg"]
          },
          {
            colorNumber: 13,
            colorName: "DARK GRAY",
            colorCode: "#B1A8A3",
            colorImages: ["BB41AG591_13.jpg"]
          },
          {
            colorNumber: 30,
            colorName: "APRICOT",
            colorCode: "#FEB58A",
            colorImages: ["BB41AG591_30.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag591",
        layout: ""
      },
      {
        category: "MARCH",
        name: "WRING ONE-TONE",
        productNumber: "AG591",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#D8D4D5",
            colorImages: ["BB41AG591_11.jpg"]
          },
          {
            colorNumber: 13,
            colorName: "DARK GRAY",
            colorCode: "#B1A8A3",
            colorImages: ["BB41AG591_13.jpg"]
          },
          {
            colorNumber: 30,
            colorName: "APRICOT",
            colorCode: "#FEB58A",
            colorImages: ["BB41AG591_30.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag591",
        layout: ""
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG492",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG492_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG492_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG492_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag492",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG492",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG492_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG492_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG492_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag492",
        layout: ""
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG492",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG492_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG492_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG492_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag492",
        layout: ""
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG491",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG491_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG491_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG491_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag491",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG491",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG491_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG491_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG491_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag491",
        layout: ""
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG491",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG491_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG491_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG491_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag491",
        layout: ""
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG493",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG493_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG493_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG493_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag493",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG493",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG493_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG493_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG493_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag493",
        layout: ""
      },
      {
        category: "MARCH",
        name: "BLOCKY",
        productNumber: "AG493",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG493_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG493_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG493_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag493",
        layout: ""
      },
      {
        category: "MARCH",
        name: "ROCK MATTE",
        productNumber: "AG402",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG402_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG402_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG402_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag402",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "ROCK MATTE",
        productNumber: "AG402",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG402_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG402_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG402_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag402",
        layout: ""
      },
      {
        category: "MARCH",
        name: "ROCK MATTE",
        productNumber: "AG402",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG402_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG402_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG402_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag402",
        layout: ""
      },
      {
        category: "MARCH",
        name: "ROCK MATTE",
        productNumber: "AG401",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG401_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG401_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG401_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag401",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "ROCK MATTE",
        productNumber: "AG401",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG401_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG401_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG401_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag401",
        layout: ""
      },
      {
        category: "MARCH",
        name: "ROCK MATTE",
        productNumber: "AG401",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG401_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG401_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG401_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag401",
        layout: ""
      },
      {
        category: "MARCH",
        name: "BATEAU MATTE",
        productNumber: "AG353",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#2A2A2A",
            colorImages: ["BB41AG353_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#D8C5B6",
            colorImages: ["BB41AG353_42.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag353",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "BATEAU MATTE",
        productNumber: "AG353",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#2A2A2A",
            colorImages: ["BB41AG353_16.jpg"]
          },
          {
            colorNumber: 42,
            colorName: "LIGHT BEIGE",
            colorCode: "#D8C5B6",
            colorImages: ["BB41AG353_42.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag353",
        layout: ""
      },
      {
        category: "MARCH",
        name: "CARD CASE MATTE",
        productNumber: "AG701",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG701_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG701_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG701_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag701",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "CARD CASE MATTE",
        productNumber: "AG701",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG701_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG701_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG701_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag701",
        layout: ""
      },
      {
        category: "MARCH",
        name: "CARD CASE MATTE",
        productNumber: "AG701",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG701_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG701_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG701_16.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag701",
        layout: ""
      },
      {
        category: "MARCH",
        name: "CASSETTE",
        productNumber: "AG741",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG741_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG741_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG741_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG741_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG741_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag741",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MARCH",
        name: "CASSETTE",
        productNumber: "AG741",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG741_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG741_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG741_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG741_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG741_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag741",
        layout: ""
      },
      {
        category: "MARCH",
        name: "CASSETTE",
        productNumber: "AG741",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG741_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG741_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG741_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG741_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG741_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag741",
        layout: ""
      },
      {
        category: "MARCH",
        name: "CASSETTE",
        productNumber: "AG741",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG741_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG741_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG741_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG741_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG741_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag741",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "CASSETTE",
        productNumber: "AG741",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#867C73",
            colorImages: ["BB41AG741_12.jpg"]
          },
          {
            colorNumber: 32,
            colorName: "ORANGE",
            colorCode: "#FF9A70",
            colorImages: ["BB41AG741_32.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#C4D73F",
            colorImages: ["BB41AG741_55.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#446FA6",
            colorImages: ["BB41AG741_72.jpg"]
          },
          {
            colorNumber: 80,
            colorName: "LAVENDER",
            colorCode: "#C0AED6",
            colorImages: ["BB41AG741_80.jpg"]
          }
        ],
        size: "-",
        release: "3月上旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag741",
        layout: ""
      },
      {
        category: "MARCH",
        name: "LINER ONE-TONE",
        productNumber: "AG711",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG711_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG711_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag711",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "LINER ONE-TONE",
        productNumber: "AG711",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG711_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG711_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag711",
        layout: ""
      },
      {
        category: "MARCH",
        name: "DAYPACK ONE-TONE",
        productNumber: "AG731",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG731_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG731_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag731",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "DAYPACK ONE-TONE",
        productNumber: "AG731",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG731_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG731_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag731",
        layout: ""
      },
      {
        category: "MARCH",
        name: "CART ONE-TONE",
        productNumber: "AG761",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG761_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG761_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag761",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "CART ONE-TONE",
        productNumber: "AG761",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG761_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG761_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag761",
        layout: ""
      },
      {
        category: "MARCH",
        name: "SADDLE BAG ONE-TONE",
        productNumber: "AG751",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG751_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG751_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag751",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "SADDLE BAG ONE-TONE",
        productNumber: "AG751",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG751_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG751_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag751",
        layout: ""
      },
      {
        category: "MARCH",
        name: "VOYAGER ONE-TONE",
        productNumber: "AG871",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG871_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG871_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag871",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MARCH",
        name: "VOYAGER ONE-TONE",
        productNumber: "AG871",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#89898B",
            colorImages: ["BB42AG871_12.jpg"]
          },
          {
            colorNumber: 41,
            colorName: "BEIGE",
            colorCode: "#D7C3AA",
            colorImages: ["BB42AG871_41.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag871",
        layout: ""
      },
      {
        category: "MARCH",
        name: "CARGO",
        productNumber: "AG151",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB42AG151_16.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag151",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "MARCH",
        name: "BATON",
        productNumber: "AG141",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB42AG141_16.jpg"]
          }
        ],
        size: "-",
        release: "3月中旬",
        ecSiteUpDate: "2024-02-29T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag141",
        layout: ""
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG522",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG522_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG522_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG522_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG522_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG522_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag522",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG522",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG522_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG522_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG522_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG522_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG522_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag522",
        layout: ""
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG522",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG522_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG522_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG522_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG522_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG522_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag522",
        layout: ""
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG522",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG522_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG522_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG522_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG522_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG522_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag522",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG522",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG522_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG522_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG522_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG522_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG522_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag522",
        layout: ""
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG521",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG521_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG521_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG521_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG521_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG521_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag521",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG521",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG521_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG521_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG521_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG521_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG521_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag521",
        layout: ""
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG521",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG521_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG521_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG521_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG521_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG521_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag521",
        layout: ""
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG521",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG521_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG521_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG521_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG521_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG521_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag521",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "PRISM PLUS",
        productNumber: "AG521",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#D6D3CE",
            colorImages: ["BB41AG521_01.jpg"]
          },
          {
            colorNumber: 3,
            colorName: "GRAY BEIGE",
            colorCode: "#9F9EA4",
            colorImages: ["BB41AG521_03.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#211F22",
            colorImages: ["BB41AG521_15.jpg"]
          },
          {
            colorNumber: 55,
            colorName: "YELLOW GREEN",
            colorCode: "#D4ED4B",
            colorImages: ["BB41AG521_55.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#423B9B",
            colorImages: ["BB41AG521_74.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag521",
        layout: ""
      },
      {
        category: "APRIL",
        name: "CARTON MATTE",
        productNumber: "AG452",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG452_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG452_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG452_16.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag452",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "APRIL",
        name: "CARTON MATTE",
        productNumber: "AG452",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG452_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG452_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG452_16.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag452",
        layout: ""
      },
      {
        category: "APRIL",
        name: "CARTON MATTE",
        productNumber: "AG452",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E0E0E0",
            colorImages: ["BB41AG452_11.jpg"]
          },
          {
            colorNumber: 14,
            colorName: "CHARCOAL GRAY",
            colorCode: "#272727",
            colorImages: ["BB41AG452_14.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#0E0E0E",
            colorImages: ["BB41AG452_16.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag452",
        layout: ""
      },
      {
        category: "APRIL",
        name: "BOSTON",
        productNumber: "AG482",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 62,
            colorName: "GREEN",
            colorCode: "#2C8D4A",
            colorImages: ["BB41AG482_62.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#363EA0",
            colorImages: ["BB41AG482_74.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#948D85",
            colorImages: ["BB41AG482_91.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag482",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "APRIL",
        name: "BOSTON",
        productNumber: "AG482",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 62,
            colorName: "GREEN",
            colorCode: "#2C8D4A",
            colorImages: ["BB41AG482_62.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#363EA0",
            colorImages: ["BB41AG482_74.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#948D85",
            colorImages: ["BB41AG482_91.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag482",
        layout: ""
      },
      {
        category: "APRIL",
        name: "BOSTON",
        productNumber: "AG482",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 62,
            colorName: "GREEN",
            colorCode: "#2C8D4A",
            colorImages: ["BB41AG482_62.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#363EA0",
            colorImages: ["BB41AG482_74.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#948D85",
            colorImages: ["BB41AG482_91.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag482",
        layout: ""
      },
      {
        category: "APRIL",
        name: "BOSTON",
        productNumber: "AG481",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 62,
            colorName: "GREEN",
            colorCode: "#2C8D4A",
            colorImages: ["BB41AG481_62.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#363EA0",
            colorImages: ["BB41AG481_74.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#948D85",
            colorImages: ["BB41AG481_91.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag481",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "APRIL",
        name: "BOSTON",
        productNumber: "AG481",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 62,
            colorName: "GREEN",
            colorCode: "#2C8D4A",
            colorImages: ["BB41AG481_62.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#363EA0",
            colorImages: ["BB41AG481_74.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#948D85",
            colorImages: ["BB41AG481_91.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag481",
        layout: ""
      },
      {
        category: "APRIL",
        name: "BOSTON",
        productNumber: "AG481",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 62,
            colorName: "GREEN",
            colorCode: "#2C8D4A",
            colorImages: ["BB41AG481_62.jpg"]
          },
          {
            colorNumber: 74,
            colorName: "ROYAL BLUE",
            colorCode: "#363EA0",
            colorImages: ["BB41AG481_74.jpg"]
          },
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#948D85",
            colorImages: ["BB41AG481_91.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag481",
        layout: ""
      },
      {
        category: "APRIL",
        name: "CRYSTAL GLOSS",
        productNumber: "AG301",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E2E2E2",
            colorImages: ["BB41AG301_11.jpg"]
          },
          {
            colorNumber: 50,
            colorName: "LIGHT YELLOW",
            colorCode: "#EAE277",
            colorImages: ["BB41AG301_50.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag301",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "CRYSTAL GLOSS",
        productNumber: "AG301",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E2E2E2",
            colorImages: ["BB41AG301_11.jpg"]
          },
          {
            colorNumber: 50,
            colorName: "LIGHT YELLOW",
            colorCode: "#EAE277",
            colorImages: ["BB41AG301_50.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag301",
        layout: ""
      },
      {
        category: "APRIL",
        name: "CRYSTAL GLOSS",
        productNumber: "AG303",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E2E2E2",
            colorImages: ["BB41AG303_11.jpg"]
          },
          {
            colorNumber: 50,
            colorName: "LIGHT YELLOW",
            colorCode: "#EAE277",
            colorImages: ["BB41AG303_50.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag303",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "CRYSTAL GLOSS",
        productNumber: "AG303",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#E2E2E2",
            colorImages: ["BB41AG303_11.jpg"]
          },
          {
            colorNumber: 50,
            colorName: "LIGHT YELLOW",
            colorCode: "#EAE277",
            colorImages: ["BB41AG303_50.jpg"]
          }
        ],
        size: "-",
        release: "4月上旬",
        ecSiteUpDate: "2024-03-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag303",
        layout: ""
      },
      {
        category: "APRIL",
        name: "DAYPACK4",
        productNumber: "AG034",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG034_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG034_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag034",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "DAYPACK4",
        productNumber: "AG034",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG034_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG034_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag034",
        layout: ""
      },
      {
        category: "APRIL",
        name: "CART",
        productNumber: "AG164",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG164_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG164_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag164",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "CART",
        productNumber: "AG164",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG164_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG164_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag164",
        layout: ""
      },
      {
        category: "APRIL",
        name: "SADDLE BAG",
        productNumber: "AG134",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG134_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG134_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag134",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "SADDLE BAG",
        productNumber: "AG134",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG134_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG134_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag134",
        layout: ""
      },
      {
        category: "APRIL",
        name: "BEETLE",
        productNumber: "AG344",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG344_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG124_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag344",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "BEETLE",
        productNumber: "AG344",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG344_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG124_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag344",
        layout: ""
      },
      {
        category: "APRIL",
        name: "VOYAGER",
        productNumber: "AG124",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG124_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG344_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag124",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "VOYAGER",
        productNumber: "AG124",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG124_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG344_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag124",
        layout: ""
      },
      {
        category: "APRIL",
        name: "CLAM WALLET",
        productNumber: "AG334",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG334_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG334_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag334",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "CLAM WALLET",
        productNumber: "AG334",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG334_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG334_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag334",
        layout: ""
      },
      {
        category: "APRIL",
        name: "OYSTER",
        productNumber: "AG324",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG324_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG324_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag324",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "APRIL",
        name: "OYSTER",
        productNumber: "AG324",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 36,
            colorName: "ORANGE",
            colorCode: "#FE7737",
            colorImages: ["BB42AG324_36.jpg"]
          },
          {
            colorNumber: 96,
            colorName: "BLACK",
            colorCode: "#828282",
            colorImages: ["BB42AG324_96.jpg"]
          }
        ],
        size: "-",
        release: "4月中旬",
        ecSiteUpDate: "2024-04-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag324",
        layout: ""
      },
      {
        category: "MAY",
        name: "QUATRO",
        productNumber: "AG821",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#E9E5E2",
            colorImages: ["BB41AG821_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#181818",
            colorImages: ["BB41AG821_15.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag821",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MAY",
        name: "QUATRO",
        productNumber: "AG821",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#E9E5E2",
            colorImages: ["BB41AG821_01.jpg"]
          },
          {
            colorNumber: 15,
            colorName: "BLACK",
            colorCode: "#181818",
            colorImages: ["BB41AG821_15.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag821",
        layout: ""
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG611",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG611_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG611_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG611_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG611_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG611_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag611",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG611",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG611_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG611_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG611_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG611_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG611_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag611",
        layout: ""
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG611",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG611_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG611_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG611_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG611_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG611_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag611",
        layout: ""
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG611",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG611_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG611_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG611_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG611_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG611_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag611",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG611",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG611_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG611_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG611_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG611_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG611_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag611",
        layout: ""
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG610",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG610_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG610_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG610_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG610_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG610_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag610",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG610",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG610_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG610_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG610_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG610_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG610_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag610",
        layout: ""
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG610",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG610_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG610_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG610_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG610_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG610_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag610",
        layout: ""
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG610",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG610_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG610_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG610_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG610_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG610_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag610",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MAY",
        name: "CARAT",
        productNumber: "AG610",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG610_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG610_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG610_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG610_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG610_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag610",
        layout: ""
      },
      {
        category: "MAY",
        name: "BAGUETTE MATTE",
        productNumber: "AG472",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#DCD9D4",
            colorImages: ["BB41AG472_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#CAC6C3",
            colorImages: ["BB41AG472_12.jpg"]
          },
          {
            colorNumber: 73,
            colorName: "TURQUOISE BLUE",
            colorCode: "#26B0BD",
            colorImages: ["BB41AG472_73.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag472",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MAY",
        name: "BAGUETTE MATTE",
        productNumber: "AG472",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#DCD9D4",
            colorImages: ["BB41AG472_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#CAC6C3",
            colorImages: ["BB41AG472_12.jpg"]
          },
          {
            colorNumber: 73,
            colorName: "TURQUOISE BLUE",
            colorCode: "#26B0BD",
            colorImages: ["BB41AG472_73.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag472",
        layout: ""
      },
      {
        category: "MAY",
        name: "BAGUETTE MATTE",
        productNumber: "AG472",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#DCD9D4",
            colorImages: ["BB41AG472_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#CAC6C3",
            colorImages: ["BB41AG472_12.jpg"]
          },
          {
            colorNumber: 73,
            colorName: "TURQUOISE BLUE",
            colorCode: "#26B0BD",
            colorImages: ["BB41AG472_73.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag472",
        layout: ""
      },
      {
        category: "MAY",
        name: "BAGUETTE MATTE",
        productNumber: "AG471",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#DCD9D4",
            colorImages: ["BB41AG471_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#CAC6C3",
            colorImages: ["BB41AG471_12.jpg"]
          },
          {
            colorNumber: 73,
            colorName: "TURQUOISE BLUE",
            colorCode: "#26B0BD",
            colorImages: ["BB41AG471_73.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag471",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MAY",
        name: "BAGUETTE MATTE",
        productNumber: "AG471",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#DCD9D4",
            colorImages: ["BB41AG471_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#CAC6C3",
            colorImages: ["BB41AG471_12.jpg"]
          },
          {
            colorNumber: 73,
            colorName: "TURQUOISE BLUE",
            colorCode: "#26B0BD",
            colorImages: ["BB41AG471_73.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag471",
        layout: ""
      },
      {
        category: "MAY",
        name: "BAGUETTE MATTE",
        productNumber: "AG471",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#DCD9D4",
            colorImages: ["BB41AG471_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#CAC6C3",
            colorImages: ["BB41AG471_12.jpg"]
          },
          {
            colorNumber: 73,
            colorName: "TURQUOISE BLUE",
            colorCode: "#26B0BD",
            colorImages: ["BB41AG471_73.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag471",
        layout: ""
      },
      {
        category: "MAY",
        name: "TORSO",
        productNumber: "AG261",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#C7C2BE",
            colorImages: ["BB41AG261_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB41AG261_16.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#393280",
            colorImages: ["BB41AG261_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag261",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MAY",
        name: "TORSO",
        productNumber: "AG261",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#C7C2BE",
            colorImages: ["BB41AG261_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB41AG261_16.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#393280",
            colorImages: ["BB41AG261_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag261",
        layout: ""
      },
      {
        category: "MAY",
        name: "TORSO",
        productNumber: "AG261",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#C7C2BE",
            colorImages: ["BB41AG261_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB41AG261_16.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#393280",
            colorImages: ["BB41AG261_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag261",
        layout: ""
      },
      {
        category: "MAY",
        name: "TORSO",
        productNumber: "AG262",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#C7C2BE",
            colorImages: ["BB41AG262_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB41AG262_16.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#393280",
            colorImages: ["BB41AG262_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag262",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MAY",
        name: "TORSO",
        productNumber: "AG262",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#C7C2BE",
            colorImages: ["BB41AG262_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB41AG262_16.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#393280",
            colorImages: ["BB41AG262_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag262",
        layout: ""
      },
      {
        category: "MAY",
        name: "TORSO",
        productNumber: "AG262",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 11,
            colorName: "LIGHT GRAY",
            colorCode: "#C7C2BE",
            colorImages: ["BB41AG262_11.jpg"]
          },
          {
            colorNumber: 16,
            colorName: "MATTE BLACK",
            colorCode: "#1E1C1D",
            colorImages: ["BB41AG262_16.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#393280",
            colorImages: ["BB41AG262_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag262",
        layout: ""
      },
      {
        category: "MAY",
        name: "FLIPPER",
        productNumber: "AG761",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG761_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG761_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG761_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG761_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG761_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag761",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "MAY",
        name: "FLIPPER",
        productNumber: "AG761",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG761_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG761_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG761_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG761_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG761_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag761",
        layout: ""
      },
      {
        category: "MAY",
        name: "FLIPPER",
        productNumber: "AG761",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG761_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG761_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG761_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG761_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG761_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag761",
        layout: ""
      },
      {
        category: "MAY",
        name: "FLIPPER",
        productNumber: "AG761",
        listImage: "",
        defaultImage: 4,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG761_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG761_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG761_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG761_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG761_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag761",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "MAY",
        name: "FLIPPER",
        productNumber: "AG761",
        listImage: "",
        defaultImage: 5,
        colors: [
          {
            colorNumber: 1,
            colorName: "WHITE",
            colorCode: "#FFFFFF",
            colorImages: ["BB41AG761_01.jpg"]
          },
          {
            colorNumber: 12,
            colorName: "GRAY",
            colorCode: "#B2AAA8",
            colorImages: ["BB41AG761_12.jpg"]
          },
          {
            colorNumber: 24,
            colorName: "RED",
            colorCode: "#C8012A",
            colorImages: ["BB41AG761_24.jpg"]
          },
          {
            colorNumber: 63,
            colorName: "EMERALD GREEN",
            colorCode: "#00B8A0",
            colorImages: ["BB41AG761_63.jpg"]
          },
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#173C97",
            colorImages: ["BB41AG761_72.jpg"]
          }
        ],
        size: "-",
        release: "5月上旬",
        ecSiteUpDate: "2024-04-30T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag761",
        layout: ""
      },
      {
        category: "MAY",
        name: "DAYPACK5",
        productNumber: "AG035",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#4392B1",
            colorImages: ["BB42AG035_72.jpg"]
          }
        ],
        size: "-",
        release: "5月中旬",
        ecSiteUpDate: "2024-05-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag035",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "MAY",
        name: "CART S",
        productNumber: "AG265",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#4392B1",
            colorImages: ["BB42AG265_72.jpg"]
          }
        ],
        size: "-",
        release: "5月中旬",
        ecSiteUpDate: "2024-05-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag265",
        layout: ""
      },
      {
        category: "MAY",
        name: "SADDLE BAG",
        productNumber: "AG135",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#4392B1",
            colorImages: ["BB42AG135_72.jpg"]
          }
        ],
        size: "-",
        release: "5月中旬",
        ecSiteUpDate: "2024-05-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag135",
        layout: ""
      },
      {
        category: "MAY",
        name: "VOYAGER",
        productNumber: "AG125",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#4392B1",
            colorImages: ["BB42AG125_72.jpg"]
          }
        ],
        size: "-",
        release: "5月中旬",
        ecSiteUpDate: "2024-05-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag125",
        layout: ""
      },
      {
        category: "MAY",
        name: "BEETLE",
        productNumber: "AG345",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 72,
            colorName: "BLUE",
            colorCode: "#4392B1",
            colorImages: ["BB42AG345_72.jpg"]
          }
        ],
        size: "-",
        release: "5月中旬",
        ecSiteUpDate: "2024-05-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag345",
        layout: ""
      },
      {
        category: "JUNE",
        name: "LUCENT METALLIC",
        productNumber: "AG623",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 21,
            colorName: "LIGHT PINK",
            colorCode: "#B9A69F",
            colorImages: ["BB41AG623_21.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9A9F99",
            colorImages: ["BB41AG623_71.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag623",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JUNE",
        name: "LUCENT METALLIC",
        productNumber: "AG623",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 21,
            colorName: "LIGHT PINK",
            colorCode: "#B9A69F",
            colorImages: ["BB41AG623_21.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9A9F99",
            colorImages: ["BB41AG623_71.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag623",
        layout: ""
      },
      {
        category: "JUNE",
        name: "LUCENT METALLIC",
        productNumber: "AG626",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 21,
            colorName: "LIGHT PINK",
            colorCode: "#B9A69F",
            colorImages: ["BB41AG626_21.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9A9F99",
            colorImages: ["BB41AG626_71.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag626",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JUNE",
        name: "LUCENT METALLIC",
        productNumber: "AG626",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 21,
            colorName: "LIGHT PINK",
            colorCode: "#B9A69F",
            colorImages: ["BB41AG626_21.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9A9F99",
            colorImages: ["BB41AG626_71.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag626",
        layout: ""
      },
      {
        category: "JUNE",
        name: "LUCENT METALLIC",
        productNumber: "AG625",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 21,
            colorName: "LIGHT PINK",
            colorCode: "#B9A69F",
            colorImages: ["BB41AG625_21.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9A9F99",
            colorImages: ["BB41AG625_71.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag625",
        layout: "type-2-2: PC2カラム・スマホ2カラム"
      },
      {
        category: "JUNE",
        name: "LUCENT METALLIC",
        productNumber: "AG625",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 21,
            colorName: "LIGHT PINK",
            colorCode: "#B9A69F",
            colorImages: ["BB41AG625_21.jpg"]
          },
          {
            colorNumber: 71,
            colorName: "LIGHT BLUE",
            colorCode: "#9A9F99",
            colorImages: ["BB41AG625_71.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag625",
        layout: ""
      },
      {
        category: "JUNE",
        name: "BASKET",
        productNumber: "AG842",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG842_68.jpg"]
          },
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG842_68.jpg"]
          },
          {
            colorNumber: 78,
            colorName: "BLUE MIX",
            colorCode: "#4E70D2",
            colorImages: ["BB41AG842_78.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag842",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JUNE",
        name: "BASKET",
        productNumber: "AG842",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG842_68.jpg"]
          },
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG842_68.jpg"]
          },
          {
            colorNumber: 78,
            colorName: "BLUE MIX",
            colorCode: "#4E70D2",
            colorImages: ["BB41AG842_78.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag842",
        layout: ""
      },
      {
        category: "JUNE",
        name: "BASKET",
        productNumber: "AG842",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG842_68.jpg"]
          },
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG842_68.jpg"]
          },
          {
            colorNumber: 78,
            colorName: "BLUE MIX",
            colorCode: "#4E70D2",
            colorImages: ["BB41AG842_78.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag842",
        layout: ""
      },
      {
        category: "JUNE",
        name: "BASKET",
        productNumber: "AG841",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 28,
            colorName: "RED MIX",
            colorCode: "#C22F39",
            colorImages: ["BB41AG841_28.jpg"]
          },
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG841_68.jpg"]
          },
          {
            colorNumber: 78,
            colorName: "BLUE MIX",
            colorCode: "#4E70D2",
            colorImages: ["BB41AG841_78.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag841",
        layout: "type-3-3: PC3カラム・スマホ3カラム"
      },
      {
        category: "JUNE",
        name: "BASKET",
        productNumber: "AG841",
        listImage: "",
        defaultImage: 2,
        colors: [
          {
            colorNumber: 28,
            colorName: "RED MIX",
            colorCode: "#C22F39",
            colorImages: ["BB41AG841_28.jpg"]
          },
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG841_68.jpg"]
          },
          {
            colorNumber: 78,
            colorName: "BLUE MIX",
            colorCode: "#4E70D2",
            colorImages: ["BB41AG841_78.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag841",
        layout: ""
      },
      {
        category: "JUNE",
        name: "BASKET",
        productNumber: "AG841",
        listImage: "",
        defaultImage: 3,
        colors: [
          {
            colorNumber: 28,
            colorName: "RED MIX",
            colorCode: "#C22F39",
            colorImages: ["BB41AG841_28.jpg"]
          },
          {
            colorNumber: 68,
            colorName: "GRREN MIX",
            colorCode: "#30B15E",
            colorImages: ["BB41AG841_68.jpg"]
          },
          {
            colorNumber: 78,
            colorName: "BLUE MIX",
            colorCode: "#4E70D2",
            colorImages: ["BB41AG841_78.jpg"]
          }
        ],
        size: "-",
        release: "6月上旬",
        ecSiteUpDate: "2024-05-31T15:00:00.000Z",
        onlineStoreLink: "/products/bb41ag841",
        layout: ""
      },
      {
        category: "JUNE",
        name: "DAYPACK METALLIC",
        productNumber: "AG532",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#E4E4E4",
            colorImages: ["BB42AG532_91.jpg"]
          }
        ],
        size: "-",
        release: "6月中旬",
        ecSiteUpDate: "2024-06-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag532",
        layout: "type-1-1: PC1カラム・スマホ1カラム"
      },
      {
        category: "JUNE",
        name: "CART METALLIC",
        productNumber: "AG662",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#E4E4E4",
            colorImages: ["BB42AG662_91.jpg"]
          }
        ],
        size: "-",
        release: "6月中旬",
        ecSiteUpDate: "2024-06-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag662",
        layout: ""
      },
      {
        category: "JUNE",
        name: "FROGGY METALLIC",
        productNumber: "AG672",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#E4E4E4",
            colorImages: ["BB42AG672_91.jpg"]
          }
        ],
        size: "-",
        release: "6月中旬",
        ecSiteUpDate: "2024-06-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag672",
        layout: ""
      },
      {
        category: "JUNE",
        name: "SADDLE BAG METALLIC",
        productNumber: "AG632",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#E4E4E4",
            colorImages: ["BB42AG632_91.jpg"]
          }
        ],
        size: "-",
        release: "6月中旬",
        ecSiteUpDate: "2024-06-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag632",
        layout: ""
      },
      {
        category: "JUNE",
        name: "VOYAGER METALLIC",
        productNumber: "AG622",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#E4E4E4",
            colorImages: ["BB42AG622_91.jpg"]
          }
        ],
        size: "-",
        release: "6月中旬",
        ecSiteUpDate: "2024-06-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag622",
        layout: ""
      },
      {
        category: "JUNE",
        name: "BEETLE METALLIC",
        productNumber: "AG842",
        listImage: "",
        defaultImage: 1,
        colors: [
          {
            colorNumber: 91,
            colorName: "SILVER",
            colorCode: "#E4E4E4",
            colorImages: ["BB42AG842_91.jpg"]
          }
        ],
        size: "-",
        release: "6月中旬",
        ecSiteUpDate: "2024-06-14T15:00:00.000Z",
        onlineStoreLink: "/products/bb42ag842",
        layout: ""
      }
    ];*/
    //this.createCatalogs();
    //this.setup();
    ///// -=====
    store.dispatch("init");
  }

  async fetch() {
    let file = this.catalogEl.getAttribute("data-file");
    if (file) {
      let data = await fetch(file);
      this.json = await data.json();
      this.createCatalogs();
      this.setup();
    } else {
      throw new Error("No file specified");
    }
  }

  setup() {
    this.isModalOpen = false;
    this.catalogs = document.querySelectorAll(".js-catalog");
    _each(this.catalogs, (catalog) => {
      catalog.addEventListener("click", (event) => {
        event.preventDefault();
        if (this.isModalOpen) {
          return;
        }
        this.isModalOpen = true;
        let modalName = catalog.getAttribute("data-modal-name");
        let catalogIndex = catalog.getAttribute("data-catalog-index");
        store.dispatch("catalogClick", {
          catalogIndex: catalogIndex
        });
        store.dispatch("openModal", {
          name: modalName,
          focus: false
        });
        gsap.delayedCall(0.02, () => {
          if (this.modal) {
            Common.toggleTabIndexActivate(false, true);
            this.modal.updateModal(modalName);
          }
        });
      });
    });

    this.modal = new Modal();
    this.anchorlink = new Anchorlink();
    this.lazyImage = new LazyImage();
    this.setupFilter();
  }

  setupFilter() {
    const filterButtons = document.querySelectorAll(".js-catalog-filter");
    _each(filterButtons, (filterButton) => {
      filterButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.execFilter(filterButton, true);
      });
    });
    this.defaultExecFilter();
    window.addEventListener("popstate", (e) => {
      this.defaultExecFilter();
    });
  }

  /**
   * 起動時のフィルタ
   */
  defaultExecFilter() {
    const filterButtons = document.querySelectorAll(".js-catalog-filter");
    const _today = new Date();
    let month = _today.getMonth();
    if (_today.getDate() === 1 && _today.getHours() < 11) {
      if (month === 0) {
        month = 11;
      } else {
        month = month - 1;
      }
    }
    const hash = Common.queryString();
    const monthStr = this.MONTHS[month];
    let isFiltered = false;
    if (hash) {
      // ハッシュがある場合
      isFiltered = this.hasInFilters(hash);
    } else {
      // 該当月の場合
      isFiltered = this.hasInFilters(monthStr);
    }

    if (!isFiltered) {
      this.execFilter(filterButtons[0], false);
    }
  }

  hasInFilters(filter) {
    let has = false;
    /*filterButtons.forEach((filterButton, index) => {
      const filterName = filterButton.getAttribute("data-filter");
      // console.log(index);
      // console.log(filterName + "/ NOW: " + monthStr);
      if (filterName === monthStr) {
        this.execFilter(filterButtons[index]);
        isFiltered = true;
      }
    });*/
    const filters = document.querySelectorAll(".js-catalog-filter");
    filters.forEach((filterButton, index) => {
      const filterName = filterButton.getAttribute("data-filter");
      if (filterName === filter) {
        this.execFilter(filters[index], false);
        has = true;
      }
    });
    return has;
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
  }

  /**
   * フィルタ処理の実行
   * @param filterButton
   */
  execFilter(filterButton, isPush = true) {
    const filter = filterButton.getAttribute("data-filter");
    const categoryName = filterButton.getAttribute("data-category-name");
    const categoryDisplay = filterButton.getAttribute("data-category-display");
    if (isPush) {
      history.pushState(null, filter, "#" + filter);
    }
    this.clearAllFilterButtons();
    filterButton.classList.add("active");
    this.filter(filter, categoryName, categoryDisplay);
    gsap.to(window, {
      duration: 0.6,
      delay: 0.2,
      scrollTo: {
        y: 0,
        autoKill: false
      },
      ease: Cubic.easeInOut
    });
  }

  // フィルター用タブボタンの状態をクリアする
  clearAllFilterButtons() {
    const activeFilterButtons = document.querySelectorAll(".js-catalog-filter.active");
    _each(activeFilterButtons, (activeFilterButton) => {
      activeFilterButton.classList.remove("active");
    });
  }

  // 表示部分のフィルタリング処理を実行
  filter(filter, categoryName, categoryDisplay) {
    this.hideAllFilters();
    this.hideAnchorlinks();
    const filterTitle = document.querySelector(".js-catalog-filtertitle");
    filterTitle.innerText = categoryDisplay; //filter.toUpperCase();
    let filterTargets = document.querySelectorAll(".filter-" + filter);
    _each(filterTargets, (filterTarget) => {
      this.updateAnchorlink(filterTarget.id, this.trimToAnchr(categoryName));
      gsap.to(filterTarget, {
        opacity: 1,
        display: "block",
        duration: 0.5,
        delay: 0.2,
        ease: Cubic.easeOut
      });
    });
  }

  // アンカーリンク表示の更新
  updateAnchorlink(id, categoryName) {
    if (!id) {
      return;
    }
    const anchorLinks = document.querySelectorAll(".js-anchorlink");
    _each(anchorLinks, (anchorLink) => {
      if (anchorLink.getAttribute("data-anchorlink") === "#" + id && anchorLink.getAttribute("data-category") === categoryName) {
        anchorLink.classList.remove("hide");
      }
    });
  }

  hideAllFilters() {
    const filterTargets = document.querySelectorAll(".js-filter-target");
    _each(filterTargets, (filterTarget) => {
      gsap.to(filterTarget, {
        opacity: 0,
        display: "none",
        duration: 0.3,
        ease: Cubic.easeOut
      });
    });
  }

  hideAnchorlinks() {
    const anchorLinks = document.querySelectorAll(".js-anchorlink");
    _each(anchorLinks, (anchorLink) => {
      anchorLink.classList.add("hide");
    });
  }

  /** ====================
   * Create
   */
  createCatalogs() {
    console.log(this.json);
    const fragment = document.createDocumentFragment();
    this.tempGroupName = "";
    this.tempCategory = "";
    this.tempLayout = "";
    this.groupHead = null;
    this.groupBody = null;
    this.json.forEach((item, index) => {
      if (item.category !== this.tempCategory) {
        this.tempCategory = item.category;
        this.tempGroupName = "";
        this.createCategory(item.category);
      }
      // グループ名（商品名）が変更した場合
      // グループヘッダーとグループボディを作成
      if (item.name !== this.tempGroupName) {
        this.tempGroupName = item.name;
        this.createAnchorlink(item.name, item.category);
        if (!this.isBasics(item.category)) {
          this.groupHead = this.createGroupHead(item);
          fragment.appendChild(this.groupHead);
        }
        this.groupBody = this.createGroupBody(item, true);
        fragment.appendChild(this.groupBody);
        this.tempLayout = item.layout;
      }
      // console.log("tempLayput:: " + this.tempLayout);
      // console.log("item.layout:::: " + item.layout);
      // レイアウトの変更が確認できた場合
      // グループボディを再作成する
      if (item.layout && item.layout !== this.tempLayout) {
        this.tempLayout = item.layout;
        this.groupBody = this.createGroupBody(item);
        fragment.appendChild(this.groupBody);
      }
      // console.log("------");

      // グループボディにカタログを追加
      if (this.groupBody) {
        const inner = this.groupBody.querySelector(".section__inner");
        inner.appendChild(this.createCatalog(item, index));
      }
    });

    this.catalogWrapEl.appendChild(fragment);
    /// this.grouped = _groupBy(this.json, "category");
  }

  createCategory() {
    const wrap = document.querySelector(".js-category-wrap");
    let category = document.createElement("a");
    let _trimCategory = this.trimToAnchr(this.tempCategory.toLowerCase());
    category.classList.add("c-catalog-header__category", "js-catalog-filter");
    category.setAttribute("data-filter", _trimCategory);
    category.setAttribute("data-category-name", _trimCategory);
    category.setAttribute("data-category-display", this.tempCategory);
    category.setAttribute("href", "/#/" + this.tempCategory.toLowerCase());
    let categoryText = document.createElement("p");
    categoryText.innerText = this.tempCategory;
    category.appendChild(categoryText);
    if (this.isBasics(this.tempCategory)) {
      let separator = document.createElement("span");
      separator.classList.add("separator");
      wrap.appendChild(separator);
    }
    wrap.appendChild(category);
  }

  isBasics(categoryName) {
    return categoryName === "BASICS" || categoryName === "BASIC";
  }

  /**
   * アンカーリンク部分を追加
   */
  createAnchorlink(name, category) {
    if (this.isBasics(category)) {
      return;
    }
    let _trimCategory = this.trimToAnchr(category);
    const wrap = document.querySelector(".js-anchorlink-wrap");
    let anchorlink = document.createElement("a");
    anchorlink.href = "#";
    anchorlink.classList.add("item");
    anchorlink.classList.add("js-anchorlink");
    anchorlink.setAttribute("data-anchorlink", "#" + _trimCategory + this.trimToAnchr(name));
    anchorlink.setAttribute("data-category", _trimCategory);
    anchorlink.setAttribute("data-offsetY", 40);
    let anchorText = document.createElement("p");
    anchorText.innerText = name;
    anchorlink.appendChild(anchorText);
    wrap.appendChild(anchorlink);
  }

  /**
   * グループのヘッダー部作成
   * @param item
   */
  createGroupHead(item) {
    let _trimCategory = this.trimToAnchr(item.category);
    const result = document.createElement("section");
    result.classList.add("c-catalog-section", "c-category-sechead", "section", "js-filter-target", "filter-" + _trimCategory);
    result.id = _trimCategory + this.trimToAnchr(item.name);
    const inner = document.createElement("div");
    inner.classList.add("section__inner");
    const title = document.createElement("h3");
    title.classList.add("type-center-onlypc");
    title.innerText = item.name;
    inner.appendChild(title);
    result.appendChild(inner);

    return result;
  }

  /**
   * グループのボディ部作成
   * @param item
   * @returns {HTMLElement}
   */
  createGroupBody(item, isFirst = false) {
    const result = document.createElement("section");
    const type = item.layout.split(":")[0] || this.DEFAULT_LAYOUT;
    result.classList.add("c-catalog-section", "c-category-secbody", "section", "js-filter-target", "filter-" + this.trimToAnchr(item.category));
    if (isFirst) {
      result.classList.add("first-body");
    }
    if (type) {
      result.classList.add(type);
    }
    const inner = document.createElement("div");
    inner.classList.add("section__inner");
    result.appendChild(inner);
    return result;
  }

  createCatalog(item, index) {
    const result = document.createElement("a");
    result.href = "#";
    result.classList.add("item", "js-catalog", "js-lazyclass");
    result.setAttribute("data-modal-name", this.MODAL_NAME);
    result.setAttribute("data-catalog-index", index);
    const defaultIndex = item.defaultImage !== "" ? parseInt(item.defaultImage, 10) - 1 : 0;
    const defaultColor = item.colors[defaultIndex] ? this.trimToAnchr(item.colors[defaultIndex].colorName) : "";
    result.setAttribute("name", `catalogmodal_item_${this.trimToName(item.name)}_${this.trimToAnchr(item.productNumber)}_${defaultColor}`);
    const img = document.createElement("img");
    img.classList.add("c-catalog__img");
    const imageSrc = item.listImage; //this.getFirstColorImage(item.colors);
    img.setAttribute("src", imageSrc);
    img.setAttribute("alt", item.name);
    result.appendChild(img);
    if (this.isGlasses(item.size)) {
      this.catalogMode = this.CATALOG_MODE_GLASSES;
      this.catalogEl.classList.add("glasses");
    }
    return result;
  }

  getFirstColorImage(colors) {
    if (!colors || !colors[0]) {
      return "";
    }
    const firstColors = colors[0].colorImages;
    return firstColors ? firstColors[0] : "";
  }

  trimToAnchr(str) {
    return str.replace(/\s+/g, "-").toLowerCase().replace(/[:\/]/g, "_").replace(/\&/g, "_");
  }

  trimToName(str) {
    return str.replace(/[：]/g, " ").replace(/\s+/g, "-").toLowerCase().replace(/[:\/]/g, "_").replace(/\&/g, "_");
  }

  removeCatalog() {
    const modal = document.querySelector(".js-catalog-modal");
    const name = modal.querySelector(".js-catalogmodal-name");
    const itemNumber = modal.querySelector(".js-catalogmodal-itemnumber");
    const colorWrap = modal.querySelector(".js-catalogmodal-colorwrap");
    const size = modal.querySelector(".js-catalogmodal-size");
    name.innerHTML = "";
    itemNumber.innerHTML = "";
    colorWrap.innerHTML = "";
    size.innerHTML = "";
  }

  /**
   * カタログモーダルの情報更新
   * @param catalogIndex
   */
  updateCatalog(catalogIndex) {
    const item = this.json[catalogIndex];
    const modal = document.querySelector(".js-catalog-modal");
    const name = modal.querySelector(".js-catalogmodal-name");
    const itemNumber = modal.querySelector(".js-catalogmodal-itemnumber");
    const colorWrap = modal.querySelector(".js-catalogmodal-colorwrap");
    const size = modal.querySelector(".js-catalogmodal-size");
    const sizeWrap = size.parentNode;
    const sizeHeader = size.previousElementSibling;
    const releaseWrap = modal.querySelector(".js-catalogmodal-releasewrap");
    const release = modal.querySelector(".js-catalogmodal-release");

    name.innerHTML = item.name;
    itemNumber.innerHTML = item.productNumber;
    size.innerHTML = item.size;
    release.innerHTML = item.release;

    if (!item.size || item.size === "-") {
      sizeWrap.classList.add("hide");
    } else {
      sizeWrap.classList.remove("hide");
    }
    if (this.isGlasses(item.size)) {
      sizeHeader.innerHTML = "レンズ";
    } else {
      sizeHeader.innerHTML = "サイズ";
    }
    if (item.release === "非表示" || !item.release) {
      releaseWrap.classList.add("hide");
    } else {
      releaseWrap.classList.remove("hide");
    }
    colorWrap.innerHTML = "";
    colorWrap.appendChild(this.createColors(item.colors, item.defaultImage, item));

    const onlineStore = modal.querySelector(".js-catalogmodal-onlinestore");
    onlineStore.setAttribute("name", "catalogmodal_item_onlinestore");
    const onlineStoreText = onlineStore.querySelector("p");
    if (onlineStoreText) {
      onlineStoreText.setAttribute("name", "catalogmodal_item_onlinestore");
    }
    onlineStore.href = item.onlineStoreLink;
    if (this.isStoreAccessable(item.ecSiteUpDate)) {
      onlineStore.classList.remove("hide");
    } else {
      onlineStore.classList.add("hide");
    }
  }

  isGlasses(size) {
    if (
      size.search("サングラス") !== -1 ||
      size.search("SUNGLASSES") !== -1 ||
      size.search("OPTICAL") !== -1 ||
      size.search("オプティカル") !== -1 ||
      size.search("ブルーライトカットレンズ") !== -1 ||
      size.search("BLUE LIGHT CUT LENSES") !== -1
    ) {
      return true;
    }
    return false;
  }

  updateImages(images) {
    const modal = document.querySelector(".js-catalog-modal");
    const imageArea = modal.querySelector(".js-catalogmodal-images");
    this.removeImages();
    imageArea.appendChild(this.createImages(images));
    this.carousel = new Carousel();
  }

  createImages(images) {
    const result = document.createDocumentFragment();
    const wrap = document.createElement("div");
    const swiper = document.createElement("div");
    const swiperWrap = document.createElement("div");
    const pagination = document.createElement("div");
    wrap.classList.add("js-carousel");
    if (images.length > 1) {
      // wrap.setAttribute("data-autoplay", "1");
      pagination.classList.add("js-carousel-pagination");
    }
    swiper.classList.add("swiper");
    swiperWrap.classList.add("swiper-wrapper");

    images.forEach((image) => {
      let img = document.createElement("img");
      const slide = document.createElement("div");
      slide.classList.add("swiper-slide");
      img.setAttribute("src", image);
      img.alt = "";
      slide.appendChild(img);
      swiperWrap.appendChild(slide);
    });

    swiper.appendChild(swiperWrap);
    swiper.appendChild(pagination);
    wrap.appendChild(swiper);
    result.appendChild(wrap);
    return result;
  }

  removeImages() {
    const modal = document.querySelector(".js-catalog-modal");
    const imageArea = modal.querySelector(".js-catalogmodal-images");
    imageArea.innerHTML = "";
    if (this.carousel) {
      this.carousel = null;
    }
  }

  /**
   * カタログモーダルの色玉更新
   * @param colors
   * @returns {DocumentFragment}
   */
  createColors(colors, defaultImage, item) {
    const fragment = document.createDocumentFragment();
    let index = 0;
    let defaultIndex = defaultImage !== "" ? parseInt(defaultImage, 10) - 1 : 0;
    const namePrefix = `catalogmodal_item_${this.trimToName(item.name)}_${this.trimToName(item.productNumber)}`;
    const activeColor = colors[defaultIndex] ? this.trimToName(colors[defaultIndex].colorName) : "";
    colors.forEach((color, index) => {
      let colorEl;
      const swatchName = `${namePrefix}_${activeColor}_colorwrap_${this.trimToName(color.colorName)}`;
      if (color.colorImages && color.colorImages.length) {
        colorEl = document.createElement("a");
        colorEl.setAttribute("href", "#");
        colorEl.setAttribute("name", swatchName);
      } else {
        colorEl = document.createElement("p");
        colorEl.setAttribute("name", swatchName);
      }

      colorEl.classList.add("category-color" + index, "category-color", "js-catalog-color");
      colorEl.setAttribute("data-color-number", color.colorNumber);
      const colorBall = document.createElement("span");
      colorBall.classList.add("catalog-colorball");
      colorBall.setAttribute("name", swatchName);
      colorBall.style.backgroundColor = color.colorCode;
      const colorName = document.createElement("span");
      colorName.classList.add("catalog-colorname");
      colorName.setAttribute("name", swatchName);
      colorName.innerText = color.colorName;
      colorEl.appendChild(colorBall);
      colorEl.appendChild(colorName);
      fragment.appendChild(colorEl);
      if (color.colorImages && color.colorImages.length) {
        colorEl.classList.add("active");
        colorEl.addEventListener("click", (e) => {
          e.preventDefault();
          this.updateImages(color.colorImages);
          if (this.modal) {
            this.modal.updateModal(this.MODAL_NAME, false);
          }
        });
      }
      if (index === defaultIndex) {
        this.updateImages(color.colorImages);
      }
      index++;
    });
    return fragment;
  }

  /**
   * オンラインストアのリンクを表示するかどうか
   * @param siteOpenDate
   * @returns {boolean}
   */
  isStoreAccessable(siteOpenDate) {
    let ecDate = new Date(siteOpenDate);
    ecDate.setHours(11);
    let now = new Date();
    return ecDate.getTime() - now.getTime() < 0;
  }

  clearModal() {
    gsap.delayedCall(0.5, () => {
      this.isModalOpen = false;
      this.removeImages();
      this.removeCatalog();
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Catalog();
});
